import React, { useState, useEffect, FC, useMemo, useCallback, useRef } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Card,
  Spinner,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
} from "reactstrap";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockContent,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import {
  Form,
  TableColumnsType,
  Input,
  Table,
  Timeline,
  Collapse as AntCollapse,
  Modal as AntModal,
  Flex,
  Spin,
  Space,
  Divider,
} from "antd";
import { FormProvider, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import usersApis from "../../api/master/users";
import boqApis from "../../api/boq/boq";
import contractorsApis from "../../api/master/contractors";
import materialsApis from "../../api/master/materials";
import supplierApis from "../../api/master/supplier";
import BOQAside from "./boqAside";
import misc from "../../api/misc/dropDowns";
import { useParams } from "react-router";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import FormMultiSelect from "../form-components/MultiSelectComponent";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import BoqMaterialModal from "./editboqmaterialmodal";
import AddBOQLineModal from "./boqCreation/AddBOQLineModal";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import sitebreakdownMasterApis from "../../api/master/sitebreakdownMaster";

const { Panel } = AntCollapse;

interface SelectOptions {
  label: string;
  value: string;
}

const ViewBoqDetails: FC<any> = () => {
  const { data: currentUser }: any = useSelector(
    (state: RootState) => state.currentUser
  );
  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { errors },
  } = methods;
  const [form] = Form.useForm();
  let { targetId } = useParams();
  const [sm, setSm] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const materialDataRef = useRef<any>({});
  const lastFetchedSiteIdRef = useRef<string | null>(null);
  const lastFetchedUsersSiteIdRef = useRef<string | null>(null);
  const [status, setstatus] = useState<any>("");
  const [data, setData] = useState<any>([]);
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "lines",
  });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [usersOptions, setUsersOptions] = useState<SelectOptions[]>([]);
  const [appUserIdToUserIdMap, setAppUserIdToUserIdMap] = useState<Record<string, number>>({});
  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [addBoqLineModal, setAddBoqLineModal] = useState<boolean>(false);
  const [editBoqLineRow, setEditBoqLineRow] = useState<any>();
  const [selectedBoqLineForMaterial, setSelectedBoqLineForMaterial] =
    useState<any>(null);
  const [
    ConsumptionTarget_GeneralDetailsEdit,
    setConsumptionTarget_GeneralDetailsEdit,
  ] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [originalLinesData, setOriginalLinesData] = useState<any[]>([]);
  const [originalHeaderData, setOriginalHeaderData] = useState<any>({});
  const [originalBoqLinesData, setOriginalBoqLinesData] = useState<any[]>([]);
  const [deletedLineItems, setDeletedLineItems] = useState<any[]>([]);
  const [deletedBoqLineIds, setDeletedBoqLineIds] = useState<number[]>([]);
  const [towerOptions, setTowerOptions] = useState<SelectOptions[]>([]);
  const [flatOptions, setFlatOptions] = useState<SelectOptions[]>([]);
  const [locationOptions, setLocationOptions] = useState<SelectOptions[]>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  const siteIdWatch = watch("siteId");
  const setAlertsWatch = watch("setAlerts");
  const navigate = useNavigate();

  const workLevelSetting = materialData?.header?.workLevelSetting;

  useEffect(() => {
    if (targetId) {
      fetchBoqDetails();
    }
  }, [targetId]);

  useEffect(() => {
    if (siteIdWatch && siteIdWatch !== lastFetchedSiteIdRef.current) {
      lastFetchedSiteIdRef.current = siteIdWatch;
      fetchContractorList(siteIdWatch + "");
    }
  }, [siteIdWatch]);

  const hasAlerts =
    Array.isArray(setAlertsWatch) && setAlertsWatch.length > 0;

  // Fetch users when setAlerts exists (either from edit form or view data)
  useEffect(() => {
    const editAlerts = hasAlerts && siteIdWatch;
    const headerAlerts = materialData?.header?.setAlerts;
    const headerSiteId = materialData?.header?.siteId;
    const viewAlerts = headerSiteId && Array.isArray(headerAlerts) && headerAlerts.length > 0;

    const siteToFetch = editAlerts ? siteIdWatch : viewAlerts ? headerSiteId : null;
    if (siteToFetch && siteToFetch?.toString() !== lastFetchedUsersSiteIdRef.current) {
      lastFetchedUsersSiteIdRef.current = siteToFetch?.toString();
      fetchUsers(siteToFetch);
    }
  }, [hasAlerts, siteIdWatch, materialData?.header?.setAlerts, materialData?.header?.siteId]);

  const loadLocationOptions = useCallback(
    async (siteIdParam?: string | number) => {
      const resolvedSiteId = siteIdParam ?? materialData?.header?.siteId;
      if (!resolvedSiteId) {
        setLocationOptions([]);
        return;
      }
      try {
        const response = await sitebreakdownMasterApis.fetchLocationsBySiteId({
          siteId: resolvedSiteId,
        });
        if (response?.status && Array.isArray(response.data)) {
          setLocationOptions(
            response.data.map((loc: any) => ({
              label: loc.locationName,
              value: loc.id?.toString(),
            }))
          );
        } else {
          setLocationOptions([]);
        }
      } catch (error) {
        console.log(error);
        setLocationOptions([]);
      }
    },
    []
  );

  useEffect(() => {
    fetchCategorys();
    fetchSites();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const lastStructureSiteIdRef = useRef<string | null>(null);
  useEffect(() => {
    const siteId = materialData?.header?.siteId?.toString();
    if (siteId && siteId !== lastStructureSiteIdRef.current) {
      lastStructureSiteIdRef.current = siteId;
      loadLocationOptions(siteId);
      sitebreakdownMasterApis
        .fetchUnitsBySiteId({ siteId: materialData.header.siteId })
        .then((response) => {
          if (response?.status && Array.isArray(response.data)) {
            setTowerOptions(
              response.data.map((unit: any) => ({
                label: unit.unitName,
                value: unit.id?.toString(),
              }))
            );
          }
        });
    }
  }, [materialData?.header?.siteId, loadLocationOptions]);

  // Load all flats only when needed (i.e., some BOQ lines have missing flat names)
  const flatsFetchedRef = useRef<boolean>(false);
  useEffect(() => {
    if (
      !materialData?.header?.siteId ||
      towerOptions.length === 0 ||
      flatsFetchedRef.current
    )
      return;

    // Check if any BOQ line is missing a flat name but has a flat ID
    const boqLines = materialData?.boqLines || [];
    const needsFlatLookup = boqLines.some(
      (bl: any) =>
        bl.siteStructureSubUnitId &&
        (!bl.siteStructureSubUnitName ||
          bl.siteStructureSubUnitName === null ||
          bl.siteStructureSubUnitName === "")
    );

    if (!needsFlatLookup) return;

    flatsFetchedRef.current = true;
    const loadAllFlats = async () => {
      // Collect only the tower IDs that have BOQ lines with missing flat names
      const towerIdsNeeded = new Set<string>();
      boqLines.forEach((bl: any) => {
        if (
          bl.siteStructureSubUnitId &&
          bl.siteStructureUnitId &&
          (!bl.siteStructureSubUnitName ||
            bl.siteStructureSubUnitName === null ||
            bl.siteStructureSubUnitName === "")
        ) {
          towerIdsNeeded.add(bl.siteStructureUnitId.toString());
        }
      });

      const towersToFetch = towerOptions.filter((t) =>
        towerIdsNeeded.has(t.value)
      );

      if (towersToFetch.length === 0) return;

      const results = await Promise.allSettled(
        towersToFetch.map((tower) =>
          sitebreakdownMasterApis.fetchSubUnitsByUnitId({
            siteId: materialData.header.siteId,
            unitId: tower.value,
          })
        )
      );
      const allFlats: SelectOptions[] = [];
      results.forEach((result) => {
        if (
          result.status === "fulfilled" &&
          result.value?.status &&
          Array.isArray(result.value.data)
        ) {
          const flats = result.value.data.map((flat: any) => ({
            label:
              flat.unitName ||
              flat.subUnitName ||
              flat.name ||
              flat.flatName ||
              `Flat ${flat.id}`,
            value: flat.id?.toString(),
          }));
          allFlats.push(...flats);
        }
      });
      setFlatOptions(allFlats);
    };
    loadAllFlats();
  }, [materialData?.header?.siteId, materialData?.boqLines, towerOptions]);

  const fetchBoqDetails = async () => {
    try {
      const res = await boqApis.fetchViewDeatils(targetId);
      const { response, status, message } = res;
      if (status) {
        // Transform response structure: response.targetHeader and response.boqLines
        const targetHeader = response?.targetHeader || {};
        const boqLines = response?.boqLines || [];

        // Convert segmentLevel back to workLevelSetting for compatibility
        const segmentLevelToWorkLevel: { [key: string]: string } = {
          Tower: "TOWER_BLOCK",
          Villa: "VILLA",
          Floor: "FLOOR",
          Flat: "FLAT",
        };
        const workLevelSetting = targetHeader.segmentLevel
          ? segmentLevelToWorkLevel[targetHeader.segmentLevel] ||
            targetHeader.segmentLevel
          : null;

        // Transform boqLines with targetLines to flat structure for backward compatibility
        const transformedLines: any[] = [];
        boqLines.forEach((boqLine: any) => {
          (boqLine.targetLines || []).forEach((targetLine: any) => {
            transformedLines.push({
              ...targetLine,
              boqLineName: boqLine.boqLineName,
              boqLineId: boqLine.id,
              siteStructureUnitId: boqLine.siteStructureUnitId,
              siteStructureUnitName: boqLine.siteStructureUnitName,
              floorNo: boqLine.floorNo,
              siteStructureSubUnitId: boqLine.siteStructureSubUnitId,
              siteStructureSubUnitName: boqLine.siteStructureSubUnitName,
              locationId: boqLine.locationId,
              locationName: boqLine.locationName,
              headerStaus: targetHeader.status,
              isEditable: targetLine.isEditable && boqLine.isEditable,
            });
          });
        });

        const transformedData = {
          header: {
            ...targetHeader,
            workLevelSetting: workLevelSetting,
          },
          lines: transformedLines,
          boqLines: boqLines, // Keep original structure too
        };

        setMaterialData(transformedData);
        setstatus(targetHeader.status);
        // Store original lines data for comparison
        setOriginalLinesData(
          JSON.parse(JSON.stringify(transformedLines || []))
        );
        // Store original header data for comparison
        setOriginalHeaderData(JSON.parse(JSON.stringify(targetHeader || {})));
        // Store original BOQ lines data for comparison
        setOriginalBoqLinesData(JSON.parse(JSON.stringify(boqLines || [])));
        setDeletedLineItems([]);
        setDeletedBoqLineIds([]);
        setShowSubmitBtm(false);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const fetchUsers = async (siteId: any) => {
    try {
      const data = await misc.fetchSiteUsers(siteId);
      if (data) {
        const filtered = data?.data?.filter((item: any) => item.appUserId) || [];
        let usersOptions = filtered.map((item: any) => ({
          label: item.userName,
          value: item.appUserId.toString(),
        }));
        setUsersOptions(usersOptions);
        // Build appUserId → userId mapping for delete payload
        const mapping: Record<string, number> = {};
        filtered.forEach((item: any) => {
          mapping[item.appUserId.toString()] = item.userId;
        });
        setAppUserIdToUserIdMap(mapping);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const fetchSites = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        let sitesOptions = data?.siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Use boqLines directly if available, otherwise transform from lines
  const boqLinesData = useMemo(() => {
    let result: any[] = [];

    // If we have the boqLines structure from API, use it directly
    if (materialData?.boqLines && Array.isArray(materialData.boqLines)) {
      result = materialData.boqLines.map((boqLine: any) => ({
        ...boqLine,
        materials: boqLine.targetLines || [],
      }));
    } else {
      // Fallback: Transform from flat lines structure
      const lines = materialData?.lines || [];
      const boqLinesMap: any = {};

      lines.forEach((line: any) => {
        const boqLineName = line?.boqLineName || "Default BOQ Line";
        const boqLineId = line?.boqLineId || `boqLine-${boqLineName}`;
        if (!boqLinesMap[boqLineId]) {
          boqLinesMap[boqLineId] = {
            boqLineName: boqLineName,
            id: boqLineId,
            siteStructureUnitId: line?.siteStructureUnitId,
            siteStructureUnitName: line?.siteStructureUnitName,
            floorNo: line?.floorNo,
            siteStructureSubUnitId: line?.siteStructureSubUnitId,
            siteStructureSubUnitName: line?.siteStructureSubUnitName,
            locationId: line?.locationId,
            locationName: line?.locationName,
            isEditable: line?.isEditable !== false,
            materials: [],
          };
        }
        boqLinesMap[boqLineId].materials.push(line);
      });

      result = Object.values(boqLinesMap);
    }

    // Enrich with names from options arrays if names are missing
    return result.map((boqLine: any) => {
      const enriched: any = { ...boqLine };

      // Enrich tower name if missing
      if (
        !enriched.siteStructureUnitName &&
        enriched.siteStructureUnitId &&
        towerOptions.length > 0
      ) {
        const tower = towerOptions.find(
          (item) =>
            item.value === enriched.siteStructureUnitId?.toString() ||
            Number(item.value) === Number(enriched.siteStructureUnitId)
        );
        if (tower) {
          enriched.siteStructureUnitName = tower.label;
        }
      }

      // Enrich flat name if missing or null
      const needsFlatName =
        !enriched.siteStructureSubUnitName ||
        enriched.siteStructureSubUnitName === null ||
        enriched.siteStructureSubUnitName === "";
      if (
        needsFlatName &&
        enriched.siteStructureSubUnitId &&
        flatOptions.length > 0
      ) {
        const flatId = enriched.siteStructureSubUnitId?.toString();
        // Try multiple lookup methods
        let flat = flatOptions.find((item) => item.value === flatId);
        if (!flat) {
          flat = flatOptions.find(
            (item) =>
              Number(item.value) === Number(enriched.siteStructureSubUnitId)
          );
        }
        if (!flat && typeof enriched.siteStructureSubUnitId === "number") {
          flat = flatOptions.find(
            (item) => Number(item.value) === enriched.siteStructureSubUnitId
          );
        }
        if (!flat && typeof enriched.siteStructureSubUnitId === "string") {
          flat = flatOptions.find(
            (item) => item.value === enriched.siteStructureSubUnitId
          );
        }
        if (flat) {
          enriched.siteStructureSubUnitName = flat.label;
        }
      }

      // Enrich location name if missing
      if (
        !enriched.locationName &&
        enriched.locationId &&
        locationOptions.length > 0
      ) {
        const location = locationOptions.find(
          (item) =>
            item.value === enriched.locationId?.toString() ||
            Number(item.value) === Number(enriched.locationId)
        );
        if (location) {
          enriched.locationName = location.label;
        }
      }

      return enriched;
    });
  }, [
    materialData?.boqLines,
    materialData?.lines,
    towerOptions,
    flatOptions,
    locationOptions,
  ]);

  // Check if the last BOQ Line has materials - enable Add BOQ Line only if it does
  const canAddBOQLine = useMemo(() => {
    if (boqLinesData.length === 0) {
      return true; // Can add first BOQ Line
    }
    const lastBOQLine = boqLinesData[boqLinesData.length - 1];
    const hasMaterials =
      (lastBOQLine?.materials && lastBOQLine.materials.length > 0) ||
      (lastBOQLine?.targetLines && lastBOQLine.targetLines.length > 0);
    return hasMaterials;
  }, [boqLinesData]);

  // Check if all BOQ lines have at least one material and at least one BOQ line exists
  const canSaveChanges = useMemo(() => {
    // Must have at least one BOQ line
    if (boqLinesData.length === 0) {
      return false; // No BOQ lines, cannot save
    }
    // Check if all BOQ lines have at least one material
    const allLinesHaveMaterials = boqLinesData.every((boqLine: any) => {
      const hasMaterials =
        (boqLine?.materials && boqLine.materials.length > 0) ||
        (boqLine?.targetLines && boqLine.targetLines.length > 0);
      return hasMaterials;
    });
    return allLinesHaveMaterials;
  }, [boqLinesData]);

  // Immediate delete function - calls API directly
  const handleImmediateDelete = useCallback(
    async (boqLineIdsToDelete: number[], targetLineIdsToDelete: number[]) => {
      try {
        setDisableSubmit(true);
        const payload: any = {};

        // Only include deletions if there are any
        if (boqLineIdsToDelete.length > 0) {
          payload.boqLinesToDelete = boqLineIdsToDelete;
        }
        if (targetLineIdsToDelete.length > 0) {
          payload.targetLinesToDelete = targetLineIdsToDelete;
        }

        // If no deletions, return early
        if (
          boqLineIdsToDelete.length === 0 &&
          targetLineIdsToDelete.length === 0
        ) {
          setDisableSubmit(false);
          return;
        }

        const res = await boqApis.newVersionboq(
          payload,
          materialData?.header?.targetId
        );
        const { status, message }: any = res;

        if (status) {
          // Refresh data after successful deletion
          await fetchBoqDetails();
          Swal.fire("Deleted!", message || "Item has been deleted.", "success");
        } else {
          Swal.fire("Error!", message || "Failed to delete item.", "error");
          setDisableSubmit(false);
        }
      } catch (error: any) {
        console.log(error);
        Swal.fire(
          "Error!",
          error?.message || "An error occurred while deleting.",
          "error"
        );
        setDisableSubmit(false);
      }
    },
    [materialData?.header?.targetId, fetchBoqDetails]
  );

  const boqLineColumns = useMemo(() => {
    const baseColumns: TableColumnsType<any> = [
      {
        title: "BOQ Line Name",
        dataIndex: "boqLineName",
        key: "boqLineName",
        fixed: "left" as const,
        width: 200,
      },
      {
        title: "Contractor",
        dataIndex: "contractorName",
        key: "contractorName",
        width: 180,
        render: (text: any) => text || "--",
      } as TableColumnsType<any>[0],
      {
        title: workLevelSetting === "VILLA" ? "Villa" : "Tower / Block",
        dataIndex: "siteStructureUnitName",
        key: "siteStructureUnitName",
        width: 150,
        render: (text: any, record: any) => {
          // First check if name exists
          if (record.siteStructureUnitName || text) {
            return record.siteStructureUnitName || text;
          }
          // Otherwise lookup from towerOptions based on ID
          if (record.siteStructureUnitId) {
            const tower = towerOptions.find(
              (item) => item.value === record.siteStructureUnitId?.toString()
            );
            return tower?.label || "--";
          }
          return "--";
        },
      } as TableColumnsType<any>[0],
      ...(workLevelSetting !== "VILLA"
        ? [
            {
              title: "Floor",
              dataIndex: "floorNo",
              key: "floorNo",
              width: 100,
              render: (text: any) => text || "--",
            } as TableColumnsType<any>[0],
            {
              title: "Flat",
              dataIndex: "siteStructureSubUnitName",
              key: "siteStructureSubUnitName",
              width: 150,
              render: (text: any, record: any) => {
                // First check if name exists (and is not null/empty)
                if (
                  record.siteStructureSubUnitName &&
                  record.siteStructureSubUnitName !== null &&
                  record.siteStructureSubUnitName !== ""
                ) {
                  return record.siteStructureSubUnitName;
                }
                if (text && text !== null && text !== "") {
                  return text;
                }
                // Otherwise lookup from flatOptions based on ID
                if (record.siteStructureSubUnitId && flatOptions.length > 0) {
                  const flatId = record.siteStructureSubUnitId?.toString();
                  // Try multiple comparison methods
                  let flat = flatOptions.find((item) => item.value === flatId);
                  if (!flat) {
                    // Try with number comparison
                    flat = flatOptions.find(
                      (item) =>
                        Number(item.value) ===
                        Number(record.siteStructureSubUnitId)
                    );
                  }
                  if (
                    !flat &&
                    typeof record.siteStructureSubUnitId === "number"
                  ) {
                    // Try direct number comparison
                    flat = flatOptions.find(
                      (item) =>
                        Number(item.value) === record.siteStructureSubUnitId
                    );
                  }
                  if (
                    !flat &&
                    typeof record.siteStructureSubUnitId === "string"
                  ) {
                    // Try string comparison
                    flat = flatOptions.find(
                      (item) => item.value === record.siteStructureSubUnitId
                    );
                  }
                  if (flat) {
                    return flat.label;
                  }
                }
                return "--";
              },
            } as TableColumnsType<any>[0],
          ]
        : []),
      {
        title: "Location",
        dataIndex: "locationName",
        key: "locationName",
        width: 150,
        render: (text: any, record: any) => {
          // First check if name exists
          if (record.locationName || text) {
            return record.locationName || text;
          }
          // Otherwise lookup from locationOptions based on ID
          if (record.locationId) {
            const location = locationOptions.find(
              (item) => item.value === record.locationId?.toString()
            );
            return location?.label || "--";
          }
          return "--";
        },
      } as TableColumnsType<any>[0],
    ];

    // Add action column if editable
    const operationStatus = ["REJECTED", "IN_PROGRESS"];
    if (!operationStatus.includes(materialData?.header?.status)) {
      baseColumns.push({
        title: "Action",
        key: "operation",
        fixed: "right" as const,
        width: 150,
        render: (text: any, record: any) => {
          // Check isEditable from API response - BOQ line should be editable
          // Default to true for newly added BOQ lines
          const isEditable = record.isEditable !== false;
          const canEdit =
            isEditable &&
            !operationStatus.includes(materialData?.header?.status);

          if (!canEdit) {
            return null;
          }

          return (
            <>
              <Button
                size="sm"
                color=""
                onClick={() => {
                  setEditBoqLineRow(record);
                  setAddBoqLineModal(true);
                }}
              >
                <Icon name="edit" />
              </Button>
              <Button
                size="sm"
                color=""
                onClick={() => {
                  // Validation: Check if this is the last BOQ line (before showing confirmation)
                  const totalBoqLines = boqLinesData.length;
                  if (totalBoqLines <= 1) {
                    Swal.fire({
                      icon: "warning",
                      title: "Cannot Delete",
                      text: "At least one BOQ line must exist. Cannot delete the last BOQ line.",
                    });
                    return;
                  }

                  Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      const boqLineId = record.id;
                      const isNewLine = !boqLineId || typeof boqLineId !== "number";

                      if (isNewLine) {
                        // Newly added BOQ line (not saved to API yet) - just remove from local state
                        setMaterialData((prev: any) => ({
                          ...prev,
                          boqLines: (prev.boqLines || []).filter(
                            (bl: any) => bl.id !== record.id && bl.key !== record.key
                          ),
                        }));
                        Swal.fire("Deleted!", "BOQ line has been removed.", "success");
                      } else {
                        // Existing BOQ line - call API to delete
                        const boqLineIdsToDelete: number[] = [boqLineId];
                        const targetLineIdsToDelete: number[] = [];

                        const materialsInBoqLine =
                          record.materials || record.targetLines || [];
                        materialsInBoqLine.forEach((material: any) => {
                          if (material.id) {
                            targetLineIdsToDelete.push(Number(material.id));
                          }
                        });

                        await handleImmediateDelete(
                          boqLineIdsToDelete,
                          targetLineIdsToDelete
                        );
                      }
                    }
                  });
                }}
              >
                <Icon name="trash" />
              </Button>
            </>
          );
        },
      } as TableColumnsType<any>[0]);
    }

    return baseColumns;
  }, [
    workLevelSetting,
    materialData?.header?.status,
    materialData?.header?.isEditable,
    towerOptions,
    flatOptions,
    locationOptions,
    handleImmediateDelete,
    boqLinesData,
  ]);

  const materialColumns = useMemo(() => {
    const baseColumns: TableColumnsType<any> = [
      {
        title: "#",
        key: "index",
        width: 50,
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: "Material Category",
        dataIndex: "categoryName",
        key: "categoryLabel",
        width: 200,
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialLabel",
        width: 200,
      },
      {
        title: "Standard Qty",
        dataIndex: "quantitySet",
        key: "quantity",
        width: 120,
        render: (text: any) => {
          if (!text) return "--";
          const num = Number(text);
          return isNaN(num) ? text : num.toFixed(2);
        },
      },
      {
        title: "UOM",
        dataIndex: "uomName",
        key: "uomName",
        width: 120,
        render: (text: any) => text || "--",
      },
      {
        title: "Standard Price",
        dataIndex: "standardPrice",
        key: "standardPrice",
        width: 120,
        render: (text: any) => {
          if (!text) return "--";
          const num = Number(text);
          return isNaN(num) ? text : num.toFixed(2);
        },
      },
    ];

    // Add action column if editable
    const materialOperationStatus = ["REJECTED", "IN_PROGRESS"];
    if (!materialOperationStatus.includes(materialData?.header?.status)) {
      baseColumns.push({
        title: "Action",
        key: "operation",
        fixed: "right" as const,
        width: 150,
        render: (text: any, record: any) => {
          // Check isEditable from API response - material (targetLine) should be editable
          // Default to true for newly added materials (isEditable is undefined)
          const isEditable = record.isEditable !== false;
          const canEdit =
            isEditable &&
            !materialOperationStatus.includes(materialData?.header?.status);

          if (!canEdit) {
            return null;
          }

          return (
            <>
              <Button
                size="sm"
                color=""
                onClick={() => {
                  setEditLineRow(record);
                  setSelectedBoqLineForMaterial(
                    boqLinesData.find(
                      (bl: any) =>
                        bl.id?.toString() === record.boqLineId?.toString() ||
                        bl.key === record.boqLineId
                    )
                  );
                  setAddNewRowModel(true);
                }}
              >
                <Icon name="edit" />
              </Button>
              <Button
                size="sm"
                color=""
                onClick={() => {
                  // Validation: Check if this is the last material in the BOQ line (before showing confirmation)
                  const boqLineId = record.boqLineId;
                  const currentBoqLine = boqLinesData.find(
                    (bl: any) =>
                      bl.id?.toString() === boqLineId?.toString() ||
                      bl.key === boqLineId
                  );

                  if (currentBoqLine) {
                    const materialsInBoqLine =
                      currentBoqLine.materials ||
                      currentBoqLine.targetLines ||
                      [];
                    if (materialsInBoqLine.length <= 1) {
                      Swal.fire({
                        icon: "warning",
                        title: "Cannot Delete",
                        text: "Each BOQ line must have at least one material. Cannot delete the last material in this BOQ line.",
                      });
                      return;
                    }
                  }

                  Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      if (!record.id) {
                        // Newly added material (not saved to API) - remove from local state
                        const boqLineId = record.boqLineId;
                        setMaterialData((prev: any) => {
                          const updatedLines = (prev.lines || []).filter(
                            (line: any) => line !== record && !(
                              line.materialId === record.materialId &&
                              line.boqLineId?.toString() === boqLineId?.toString()
                            )
                          );
                          const updatedBoqLines = (prev.boqLines || []).map(
                            (bl: any) => {
                              if (
                                bl.id?.toString() === boqLineId?.toString() ||
                                bl.key === boqLineId
                              ) {
                                return {
                                  ...bl,
                                  materials: (bl.materials || []).filter(
                                    (m: any) => m !== record && !(
                                      m.materialId === record.materialId && !m.id
                                    )
                                  ),
                                  targetLines: (bl.targetLines || []).filter(
                                    (m: any) => m !== record && !(
                                      m.materialId === record.materialId && !m.id
                                    )
                                  ),
                                };
                              }
                              return bl;
                            }
                          );
                          return { ...prev, lines: updatedLines, boqLines: updatedBoqLines };
                        });
                        Swal.fire("Deleted!", "Material has been removed.", "success");
                      } else {
                        // Existing material - call API to delete
                        const targetLineIdsToDelete: number[] = [Number(record.id)];
                        await handleImmediateDelete([], targetLineIdsToDelete);
                      }
                    }
                  });
                }}
              >
                <Icon name="trash" />
              </Button>
            </>
          );
        },
      } as TableColumnsType<any>[0]);
    }

    return baseColumns;

    // Add action column if editable
    const operationStatus = ["REJECTED", "IN_PROGRESS"];
    if (!operationStatus.includes(materialData?.header?.status)) {
      baseColumns.push({
        title: "Action",
        key: "operation",
        fixed: "right" as const,
        width: 150,
        render: (text: any, record: any) => {
          // Check if this material is editable
          const isEditable =
            record.isEditable !== false &&
            (materialData?.header?.isEditable !== false ||
              materialData?.header?.status === "Active");
          const operationStatus = ["REJECTED", "IN_PROGRESS"];
          const canEdit =
            isEditable &&
            !operationStatus.includes(materialData?.header?.status);

          if (!canEdit) {
            return null;
          }

          return (
            <>
              <Button
                size="sm"
                color=""
                onClick={() => {
                  setEditLineRow(record);
                }}
              >
                <Icon name="edit" />
              </Button>
              <Button
                size="sm"
                color=""
                className="ml-1"
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to delete this item?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Add to deleted items if it's an existing item with id
                      if (record.id != null && record.id !== undefined) {
                        setDeletedLineItems((prev) => [...prev, record]);
                      }

                      // Remove from current lines
                      setMaterialData((prev: any) => {
                        const filteredLines = prev.lines.filter((item: any) => {
                          if (record.id != null && record.id !== undefined) {
                            return Number(item.id) !== Number(record.id);
                          } else {
                            return (
                              Number(item.materialId) !==
                              Number(record.materialId)
                            );
                          }
                        });

                        return {
                          ...prev,
                          lines: filteredLines,
                        };
                      });

                      setShowSubmitBtm(true);
                      Swal.fire(
                        "Deleted!",
                        "The item has been deleted.",
                        "success"
                      );
                    }
                  });
                }}
              >
                <Icon name="trash" />
              </Button>
            </>
          );
        },
      } as TableColumnsType<any>[0]);
    }

    return baseColumns;
  }, [
    materialData?.header?.status,
    materialData?.header?.isEditable,
    boqLinesData,
    handleImmediateDelete,
  ]);

  useEffect(() => {
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  const categorizeLineItems = () => {
    const currentLines = materialData?.lines || [];

    const existingLineItems: any[] = [];
    const updatedLineItems: any[] = [];
    const newLineItems: any[] = [];

    // Check current lines
    currentLines.forEach((currentLine: any) => {
      // Check if this is an existing line (has linesid and not null/undefined)
      if (currentLine.id != null && currentLine.id !== undefined) {
        const originalLine = originalLinesData.find(
          (orig: any) => Number(orig.id) === Number(currentLine.id)
        );

        if (originalLine) {
          // This is an existing line - check if it has been modified
          const isModified =
            Number(originalLine.materialId) !==
              Number(currentLine.materialId) ||
            Number(originalLine.categoryId) !==
              Number(currentLine.categoryId) ||
            Number(originalLine.quantitySet) !==
              Number(currentLine.quantitySet) ||
            Number(originalLine.uomId) !== Number(currentLine.uomId) ||
            Number(originalLine.standardPrice || 0) !==
              Number(currentLine.standardPrice || 0);

          if (isModified) {
            // Item was updated
            updatedLineItems.push({
              id: Number(currentLine.id),
              materialId: Number(currentLine.materialId),
              categoryId: Number(currentLine.categoryId),
              quantitySet: Number(currentLine.quantitySet),
              standardPrice: currentLine.standardPrice ? Number(currentLine.standardPrice) : null,
            });
          } else {
            // Item unchanged
            existingLineItems.push({
              id: Number(currentLine.id),
              materialId: Number(currentLine.materialId),
              categoryId: Number(currentLine.categoryId),
              quantitySet: Number(currentLine.quantitySet),
              standardPrice: currentLine.standardPrice ? Number(currentLine.standardPrice) : null,
            });
          }
        } else {
          // Has linesid but not found in original (shouldn't happen, but treat as updated)
          updatedLineItems.push({
            id: Number(currentLine.id),
            materialId: Number(currentLine.materialId),
            categoryId: Number(currentLine.categoryId),
            quantitySet: Number(currentLine.quantitySet),
            standardPrice: currentLine.standardPrice ? Number(currentLine.standardPrice) : null,
          });
        }
      } else {
        // This is a new line (doesn't have linesid)
        newLineItems.push({
          materialId: Number(currentLine.materialId),
          categoryId: Number(currentLine.categoryId),
          quantitySet: Number(currentLine.quantitySet),
          standardPrice: currentLine.standardPrice ? Number(currentLine.standardPrice) : null,
        });
      }
    });

    // Deleted items
    const deletedItems = deletedLineItems.map((item: any) => ({
      id: Number(item.id),
      materialId: Number(item.materialId),
    }));

    return {
      existingLineItems,
      updatedLineItems,
      deletedLineItems: deletedItems,
      newLineItems,
    };
  };

  const SubmitChanges = async () => {
    try {
      const lineData = categorizeLineItems();

      // Normalize values for comparison
      const normalizeValue = (key: string, value: any) => {
        if (
          key === "limitPostTargetConsumption" ||
          key === "limitPostTargetOrder"
        ) {
          return value === "Yes" || value === 1 ? 1 : 0;
        }
        if (key === "contractorId" || key === "siteId") {
          return value ? Number(value) : null;
        }
        return value;
      };

      // Build headerData with only changed fields
      const headerData: any = {};

      // List of fields to check
      const headerFields = [
        "targetNumber",
        "boqTitle",
        "siteId",
        "limitPostTargetConsumption",
        "limitPostTargetOrder",
        "setAlerts",
      ];

      headerFields.forEach((field) => {
        const currentValue = normalizeValue(
          field,
          materialData?.header?.[field]
        );
        const originalValue = normalizeValue(
          field,
          originalHeaderData?.[field]
        );

        // For arrays, do deep comparison
        if (field === "setAlerts") {
          const currentAlerts = Array.isArray(currentValue) ? currentValue : [];
          const originalAlerts = Array.isArray(originalValue)
            ? originalValue
            : [];

          // Convert string values to numbers for API
          const currentAlertsNumbers = currentAlerts.map((alert: any) =>
            typeof alert === "string" ? Number(alert) : Number(alert)
          );
          const originalAlertsNumbers = originalAlerts.map((alert: any) =>
            typeof alert === "string" ? Number(alert) : Number(alert)
          );

          if (
            JSON.stringify(currentAlertsNumbers.sort((a, b) => a - b)) !==
            JSON.stringify(originalAlertsNumbers.sort((a, b) => a - b))
          ) {
            headerData[field] = currentAlertsNumbers;
          }
        } else {
          // For other fields, do direct comparison
          if (currentValue !== originalValue) {
            headerData[field] = currentValue;
          }
        }
      });

      // Handle boqUsers (notifyUsers form field → boqUsers API field)
      // Only compare if user actually edited general info (notifyUsers was set)
      let boqUsersToDeleteList: number[] = [];
      if (materialData?.header?.notifyUsers !== undefined) {
        const currentNotifyUsers = Array.isArray(materialData.header.notifyUsers)
          ? materialData.header.notifyUsers.map((id: any) => Number(id))
          : [];
        const originalBoqUsers = Array.isArray(originalHeaderData?.boqUsers)
          ? originalHeaderData.boqUsers.map((u: any) => Number(u.userId))
          : [];

        const currentSorted = [...currentNotifyUsers].sort((a, b) => a - b);
        const originalSorted = [...originalBoqUsers].sort((a, b) => a - b);

        if (JSON.stringify(currentSorted) !== JSON.stringify(originalSorted)) {
          const newUserIds = currentNotifyUsers.filter(
            (id: number) => !originalBoqUsers.includes(id)
          );
          if (newUserIds.length > 0) {
            // Send appUserId as userId for new users
            headerData.boqUsers = newUserIds.map((id: number) => ({ userId: id }));
          }

          const deletedAppUserIds = originalBoqUsers.filter(
            (id: number) => !currentNotifyUsers.includes(id)
          );
          if (deletedAppUserIds.length > 0) {
            // Send boqUserId for the delete payload
            boqUsersToDeleteList = deletedAppUserIds
              .map((appUserId: number) => {
                const boqUser = originalHeaderData.boqUsers.find(
                  (u: any) => Number(u.userId) === appUserId
                );
                return boqUser ? Number(boqUser.boqUserId) : null;
              })
              .filter((id: any): id is number => id !== null);
          }
        }
      }

      // Check if there are any line changes
      const hasLineChanges =
        lineData.updatedLineItems.length > 0 ||
        lineData.deletedLineItems.length > 0 ||
        lineData.newLineItems.length > 0;

      // Check if there are any header changes
      const hasHeaderChanges = Object.keys(headerData).length > 0;

      // Check for BOQ line property changes (even if no material changes)
      const currentBoqLines = materialData?.boqLines || [];
      const originalBoqLines = originalBoqLinesData || [];
      let hasBoqLinePropertyChanges = false;

      // Quick check: compare current boqLines with original to detect property changes
      if (currentBoqLines.length > 0 && originalBoqLines.length > 0) {
        hasBoqLinePropertyChanges = currentBoqLines.some((currentBl: any) => {
          const originalBl = originalBoqLines.find(
            (obl: any) => Number(obl.id) === Number(currentBl.id)
          );
          if (!originalBl) return false;

          return (
            (currentBl.boqLineName || "") !== (originalBl.boqLineName || "") ||
            (currentBl.contractorId?.toString() || "") !==
              (originalBl.contractorId?.toString() || "") ||
            (currentBl.siteStructureUnitId?.toString() || "") !==
              (originalBl.siteStructureUnitId?.toString() || "") ||
            (currentBl.siteStructureSubUnitId?.toString() || "") !==
              (originalBl.siteStructureSubUnitId?.toString() || "") ||
            (currentBl.floorNo || "") !== (originalBl.floorNo || "") ||
            (currentBl.locationId?.toString() || "") !==
              (originalBl.locationId?.toString() || "")
          );
        });
      }

      // Build payload conditionally - only include header if there are header changes
      const payload: any = {};

      if (hasHeaderChanges) {
        payload.header = headerData;
      }

      // Add boqUsersToDelete if any
      if (boqUsersToDeleteList.length > 0) {
        payload.boqUsersToDelete = boqUsersToDeleteList;
      }

      // Transform to API format if there are line changes OR BOQ line property changes
      if (
        hasLineChanges ||
        hasBoqLinePropertyChanges ||
        deletedBoqLineIds.length > 0
      ) {
        // Filter out lines from deleted BOQ lines
        const currentLines = (materialData?.lines || []).filter((line: any) => {
          const lineBoqLineId = line.boqLineId;
          // Exclude lines that belong to deleted BOQ lines
          if (lineBoqLineId && deletedBoqLineIds.length > 0) {
            return !deletedBoqLineIds.some(
              (deletedId: number) => Number(lineBoqLineId) === Number(deletedId)
            );
          }
          return true;
        });
        const originalBoqLines = originalBoqLinesData || [];

        // Track which target lines are updated
        const updatedTargetLineIds = new Set(
          lineData.updatedLineItems.map((item: any) => Number(item.id))
        );

        // Track new lines by their unique combination
        const newLineKeys = new Set(
          lineData.newLineItems.map(
            (item: any) =>
              `${Number(item.materialId)}-${Number(item.categoryId)}-${Number(
                item.quantitySet
              )}`
          )
        );

        // Get deleted target line IDs
        const targetLinesToDelete: number[] = [];
        lineData.deletedLineItems.forEach((deleted: any) => {
          if (deleted.id) {
            targetLinesToDelete.push(Number(deleted.id));
          }
        });

        // Get deleted BOQ line IDs from state
        const boqLinesToDelete: number[] = [...deletedBoqLineIds];

        // Group changed lines by BOQ line (only include updated/new lines)
        const boqLinesMap: any = {};

        // First, check for BOQ line property changes (like boqLineName)
        // Group lines by boqLineId to check for BOQ line changes
        const boqLineGroups: any = {};
        currentLines.forEach((line: any) => {
          const boqLineId = line?.boqLineId;
          if (!boqLineId) return;

          const normalizedBoqLineId = boqLineId?.toString();
          if (!boqLineGroups[normalizedBoqLineId]) {
            boqLineGroups[normalizedBoqLineId] = {
              boqLineId: normalizedBoqLineId,
              boqLineName: line.boqLineName,
              siteStructureUnitId: line.siteStructureUnitId,
              siteStructureSubUnitId: line.siteStructureSubUnitId,
              floorNo: line.floorNo,
              locationId: line.locationId,
              lines: [],
            };
          }
          boqLineGroups[normalizedBoqLineId].lines.push(line);
        });

        // Check each BOQ line group for changes
        Object.values(boqLineGroups).forEach((group: any) => {
          const originalBoqLine = originalBoqLines.find((bl: any) => {
            const blId = bl.id?.toString();
            const lineIdStr = group.boqLineId?.toString();
            if (blId === lineIdStr) return true;
            if (lineIdStr?.startsWith("boqLine-")) {
              const extractedId = lineIdStr.replace("boqLine-", "");
              return blId === extractedId;
            }
            if (!isNaN(Number(blId)) && !isNaN(Number(lineIdStr))) {
              return Number(blId) === Number(lineIdStr);
            }
            return false;
          });

          // Check if BOQ line properties changed
          if (originalBoqLine) {
            const boqLineChanged =
              (group.boqLineName || "") !==
                (originalBoqLine.boqLineName || "") ||
              (group.siteStructureUnitId?.toString() || "") !==
                (originalBoqLine.siteStructureUnitId?.toString() || "") ||
              (group.siteStructureSubUnitId?.toString() || "") !==
                (originalBoqLine.siteStructureSubUnitId?.toString() || "") ||
              (group.floorNo || "") !== (originalBoqLine.floorNo || "") ||
              (group.locationId?.toString() || "") !==
                (originalBoqLine.locationId?.toString() || "");

            if (boqLineChanged) {
              // Initialize or update BOQ line in map if it has property changes
              // Only include properties that actually changed
              if (!boqLinesMap[group.boqLineId]) {
                boqLinesMap[group.boqLineId] = {
                  id: originalBoqLine?.id ? Number(originalBoqLine.id) : null,
                  targetLines: [],
                };
              }
              const boqLineData = boqLinesMap[group.boqLineId];

              if (
                (group.boqLineName || "") !==
                (originalBoqLine.boqLineName || "")
              ) {
                boqLineData.boqLineName =
                  group.boqLineName || originalBoqLine?.boqLineName;
              }
              if (
                (group.siteStructureUnitId?.toString() || "") !==
                (originalBoqLine.siteStructureUnitId?.toString() || "")
              ) {
                boqLineData.siteStructureUnitId = group.siteStructureUnitId
                  ? Number(group.siteStructureUnitId)
                  : originalBoqLine?.siteStructureUnitId
                  ? Number(originalBoqLine.siteStructureUnitId)
                  : null;
              }
              if (
                (group.siteStructureSubUnitId?.toString() || "") !==
                (originalBoqLine.siteStructureSubUnitId?.toString() || "")
              ) {
                boqLineData.siteStructureSubUnitId =
                  group.siteStructureSubUnitId
                    ? Number(group.siteStructureSubUnitId)
                    : originalBoqLine?.siteStructureSubUnitId
                    ? Number(originalBoqLine.siteStructureSubUnitId)
                    : null;
              }
              if ((group.floorNo || "") !== (originalBoqLine.floorNo || "")) {
                boqLineData.floorNo =
                  group.floorNo || originalBoqLine?.floorNo || null;
              }
              if (
                (group.locationId?.toString() || "") !==
                (originalBoqLine.locationId?.toString() || "")
              ) {
                boqLineData.locationId = group.locationId
                  ? Number(group.locationId)
                  : originalBoqLine?.locationId
                  ? Number(originalBoqLine.locationId)
                  : null;
              }

              boqLinesMap[group.boqLineId] = boqLineData;
            }
          } else {
            // This is a new BOQ line (doesn't exist in original)
            // Get properties from current materialData.boqLines
            const currentBoqLine = (materialData?.boqLines || []).find(
              (bl: any) => {
                const blId = bl.id?.toString() || bl.key?.toString();
                const groupId = group.boqLineId?.toString();
                return (
                  blId === groupId ||
                  bl.key === group.boqLineId ||
                  bl.id === group.boqLineId
                );
              }
            );

            if (currentBoqLine && !boqLinesMap[group.boqLineId]) {
              // For new BOQ lines, include all required properties
              boqLinesMap[group.boqLineId] = {
                id: null, // New BOQ line
                boqLineName: currentBoqLine.boqLineName || group.boqLineName,
                siteStructureUnitId: currentBoqLine.siteStructureUnitId
                  ? Number(currentBoqLine.siteStructureUnitId)
                  : group.siteStructureUnitId
                  ? Number(group.siteStructureUnitId)
                  : null,
                siteStructureSubUnitId: currentBoqLine.siteStructureSubUnitId
                  ? Number(currentBoqLine.siteStructureSubUnitId)
                  : group.siteStructureSubUnitId
                  ? Number(group.siteStructureSubUnitId)
                  : null,
                floorNo: currentBoqLine.floorNo || group.floorNo || null,
                locationId: currentBoqLine.locationId
                  ? Number(currentBoqLine.locationId)
                  : group.locationId
                  ? Number(group.locationId)
                  : null,
                targetLines: [],
              };
            }
          }
        });

        // Process only updated and new lines
        currentLines.forEach((line: any, index: number) => {
          const lineId = line.id ? Number(line.id) : null;
          const isUpdated = lineId && updatedTargetLineIds.has(lineId);

          // Check if this is a new line from newLineItems
          const lineKey = `${Number(line.materialId)}-${Number(
            line.categoryId
          )}-${Number(line.quantitySet)}`;
          const isNew = !lineId && newLineKeys.has(lineKey);

          // Only process if this line is updated or new
          if (isUpdated || isNew) {
            // Try to find boqLineId from the line, or find it from original data
            let boqLineId = line?.boqLineId;

            // If boqLineId is missing, try to find it from original data
            if (!boqLineId && lineId) {
              // Find which BOQ line contains this target line
              const containingBoqLine = originalBoqLines.find((bl: any) =>
                (bl.targetLines || []).some(
                  (tl: any) => Number(tl.id) === lineId
                )
              );
              if (containingBoqLine) {
                boqLineId = containingBoqLine.id;
              }
            }

            // If still no boqLineId, skip this line (shouldn't happen, but safety check)
            if (!boqLineId) {
              return;
            }

            // Normalize boqLineId for map key (handle both number and string formats)
            const normalizedBoqLineId = boqLineId?.toString();

            // Find original BOQ line to get its ID
            const originalBoqLine = originalBoqLines.find((bl: any) => {
              const blId = bl.id?.toString();
              const lineIdStr = boqLineId?.toString();
              // Try direct match first
              if (blId === lineIdStr) return true;
              // Try if boqLineId is a string like "boqLine-16" and bl.id is 16
              if (lineIdStr?.startsWith("boqLine-")) {
                const extractedId = lineIdStr.replace("boqLine-", "");
                return blId === extractedId;
              }
              // Try numeric comparison
              if (!isNaN(Number(blId)) && !isNaN(Number(lineIdStr))) {
                return Number(blId) === Number(lineIdStr);
              }
              return false;
            });

            // Check if this is a new BOQ line (not found in original)
            // Also check if boqLineId is a generated ID (starts with "boqLine-" and contains timestamp)
            const isGeneratedId =
              boqLineId?.toString().startsWith("boqLine-") &&
              boqLineId?.toString().includes("-") &&
              boqLineId?.toString().split("-").length > 2;
            const isNewBoqLine = !originalBoqLine || isGeneratedId;

            // Initialize or update the BOQ line entry
            if (!boqLinesMap[normalizedBoqLineId]) {
              if (isNewBoqLine) {
                // For new BOQ lines, get properties from current materialData.boqLines or from line data

                // Try multiple matching strategies
                let currentBoqLine = (materialData?.boqLines || []).find(
                  (bl: any) => {
                    const blId = bl.id?.toString() || bl.key?.toString();
                    const lineIdStr = boqLineId?.toString();
                    return (
                      blId === lineIdStr ||
                      bl.key === boqLineId ||
                      bl.id === boqLineId ||
                      bl.id?.toString() === lineIdStr ||
                      bl.key?.toString() === lineIdStr
                    );
                  }
                );

                // If not found by ID, try matching by boqLineName if unique
                if (!currentBoqLine && line.boqLineName) {
                  const matchingByName = (materialData?.boqLines || []).filter(
                    (bl: any) => bl.boqLineName === line.boqLineName
                  );
                  if (matchingByName.length === 1) {
                    currentBoqLine = matchingByName[0];
                  }
                }

                // If found in current data, use it; otherwise use data from line
                if (currentBoqLine) {
                  boqLinesMap[normalizedBoqLineId] = {
                    id: null, // New BOQ line
                    boqLineName: currentBoqLine.boqLineName || null,
                    siteStructureUnitId:
                      currentBoqLine.siteStructureUnitId !== undefined &&
                      currentBoqLine.siteStructureUnitId !== null
                        ? Number(currentBoqLine.siteStructureUnitId)
                        : null,
                    siteStructureSubUnitId:
                      currentBoqLine.siteStructureSubUnitId !== undefined &&
                      currentBoqLine.siteStructureSubUnitId !== null
                        ? Number(currentBoqLine.siteStructureSubUnitId)
                        : null,
                    floorNo:
                      currentBoqLine.floorNo !== undefined &&
                      currentBoqLine.floorNo !== null
                        ? currentBoqLine.floorNo
                        : null,
                    locationId:
                      currentBoqLine.locationId !== undefined &&
                      currentBoqLine.locationId !== null
                        ? Number(currentBoqLine.locationId)
                        : null,
                    targetLines: [],
                  };
                } else if (line.boqLineName || line.siteStructureUnitId) {
                  // Fallback: get from line data - ALWAYS set from line if available
                  boqLinesMap[normalizedBoqLineId] = {
                    id: null, // New BOQ line
                    boqLineName: line.boqLineName || "New BOQ Line",
                    siteStructureUnitId:
                      line.siteStructureUnitId !== undefined &&
                      line.siteStructureUnitId !== null
                        ? Number(line.siteStructureUnitId)
                        : null,
                    siteStructureSubUnitId:
                      line.siteStructureSubUnitId !== undefined &&
                      line.siteStructureSubUnitId !== null
                        ? Number(line.siteStructureSubUnitId)
                        : null,
                    floorNo:
                      line.floorNo !== undefined && line.floorNo !== null
                        ? line.floorNo
                        : null,
                    locationId:
                      line.locationId !== undefined && line.locationId !== null
                        ? Number(line.locationId)
                        : null,
                    targetLines: [],
                  };
                } else {
                  // Last resort: create with nulls
                  boqLinesMap[normalizedBoqLineId] = {
                    id: null,
                    boqLineName: null,
                    siteStructureUnitId: null,
                    siteStructureSubUnitId: null,
                    floorNo: null,
                    locationId: null,
                    targetLines: [],
                  };
                }
              } else {
                // When processing target line changes for existing BOQ lines
                // BUT if id will be null, it's actually a new BOQ line and needs properties
                const willHaveNullId = !originalBoqLine?.id || isGeneratedId;

                if (willHaveNullId) {
                  // This is actually a new BOQ line, set properties from line data
                  const currentBoqLine = (materialData?.boqLines || []).find(
                    (bl: any) => {
                      const blId = bl.id?.toString() || bl.key?.toString();
                      const lineIdStr = boqLineId?.toString();
                      return (
                        blId === lineIdStr ||
                        bl.key === boqLineId ||
                        bl.id === boqLineId
                      );
                    }
                  );

                  if (currentBoqLine) {
                    boqLinesMap[normalizedBoqLineId] = {
                      id: null,
                      boqLineName: currentBoqLine.boqLineName,
                      siteStructureUnitId: currentBoqLine.siteStructureUnitId
                        ? Number(currentBoqLine.siteStructureUnitId)
                        : null,
                      siteStructureSubUnitId:
                        currentBoqLine.siteStructureSubUnitId
                          ? Number(currentBoqLine.siteStructureSubUnitId)
                          : null,
                      floorNo: currentBoqLine.floorNo || null,
                      locationId: currentBoqLine.locationId
                        ? Number(currentBoqLine.locationId)
                        : null,
                      targetLines: [],
                    };
                  } else if (line.boqLineName || line.siteStructureUnitId) {
                    boqLinesMap[normalizedBoqLineId] = {
                      id: null,
                      boqLineName: line.boqLineName || null,
                      siteStructureUnitId: line.siteStructureUnitId
                        ? Number(line.siteStructureUnitId)
                        : null,
                      siteStructureSubUnitId: line.siteStructureSubUnitId
                        ? Number(line.siteStructureSubUnitId)
                        : null,
                      floorNo: line.floorNo || null,
                      locationId: line.locationId
                        ? Number(line.locationId)
                        : null,
                      targetLines: [],
                    };
                  } else {
                    // Last resort
                    boqLinesMap[normalizedBoqLineId] = {
                      id: null,
                      boqLineName: null,
                      siteStructureUnitId: null,
                      siteStructureSubUnitId: null,
                      floorNo: null,
                      locationId: null,
                      targetLines: [],
                    };
                  }
                } else {
                  // Existing BOQ line - only include id and targetLines
                  // BOQ line properties will be added in the first loop if they changed
                  boqLinesMap[normalizedBoqLineId] = {
                    id: originalBoqLine?.id ? Number(originalBoqLine.id) : null,
                    targetLines: [],
                  };
                }
              }
            } else if (isNewBoqLine) {
              // Always ensure properties are set for new BOQ lines
              const needsProperties =
                !boqLinesMap[normalizedBoqLineId].boqLineName ||
                boqLinesMap[normalizedBoqLineId].siteStructureUnitId ===
                  undefined ||
                boqLinesMap[normalizedBoqLineId].siteStructureSubUnitId ===
                  undefined;

              if (needsProperties) {
                // Entry exists but is missing properties - add them for new BOQ lines
                const currentBoqLine = (materialData?.boqLines || []).find(
                  (bl: any) => {
                    const blId = bl.id?.toString() || bl.key?.toString();
                    const lineIdStr = boqLineId?.toString();
                    return (
                      blId === lineIdStr ||
                      bl.key === boqLineId ||
                      bl.id === boqLineId
                    );
                  }
                );

                if (currentBoqLine) {
                  boqLinesMap[normalizedBoqLineId] = {
                    ...boqLinesMap[normalizedBoqLineId],
                    boqLineName: currentBoqLine.boqLineName,
                    siteStructureUnitId: currentBoqLine.siteStructureUnitId
                      ? Number(currentBoqLine.siteStructureUnitId)
                      : null,
                    siteStructureSubUnitId:
                      currentBoqLine.siteStructureSubUnitId
                        ? Number(currentBoqLine.siteStructureSubUnitId)
                        : null,
                    floorNo: currentBoqLine.floorNo || null,
                    locationId: currentBoqLine.locationId
                      ? Number(currentBoqLine.locationId)
                      : null,
                  };
                } else if (line) {
                  // Fallback: get from line data
                  boqLinesMap[normalizedBoqLineId] = {
                    ...boqLinesMap[normalizedBoqLineId],
                    boqLineName: line.boqLineName || "New BOQ Line",
                    siteStructureUnitId: line.siteStructureUnitId
                      ? Number(line.siteStructureUnitId)
                      : null,
                    siteStructureSubUnitId: line.siteStructureSubUnitId
                      ? Number(line.siteStructureSubUnitId)
                      : null,
                    floorNo: line.floorNo || null,
                    locationId: line.locationId
                      ? Number(line.locationId)
                      : null,
                  };
                }
              }
            }

            // Add target line (only updated/new ones)
            // For updated lines, only include changed fields
            // For new lines, include all required fields
            const targetLine: any = {
              id: lineId,
            };

            if (isUpdated && lineId) {
              // Find original line to compare
              const originalLine = originalLinesData.find(
                (orig: any) => Number(orig.id) === lineId
              );

              if (originalLine) {
                // Only include fields that have changed
                if (
                  Number(originalLine.materialId) !== Number(line.materialId)
                ) {
                  targetLine.materialId = Number(line.materialId);
                }
                if (
                  Number(originalLine.categoryId) !== Number(line.categoryId)
                ) {
                  targetLine.categoryId = Number(line.categoryId);
                }
                if (Number(originalLine.uomId) !== Number(line.uomId)) {
                  targetLine.uomId = Number(line.uomId);
                }
                if (
                  Number(originalLine.quantitySet) !== Number(line.quantitySet)
                ) {
                  targetLine.quantity = Number(line.quantitySet);
                }
                if (
                  Number(originalLine.standardPrice || 0) !== Number(line.standardPrice || 0)
                ) {
                  targetLine.standardPrice = line.standardPrice ? Number(line.standardPrice) : null;
                }
              } else {
                // If original not found, include all fields (shouldn't happen)
                targetLine.materialId = Number(line.materialId);
                targetLine.categoryId = Number(line.categoryId);
                targetLine.uomId = Number(line.uomId);
                targetLine.quantity = Number(line.quantitySet);
                targetLine.standardPrice = line.standardPrice ? Number(line.standardPrice) : null;
              }
            } else if (isNew) {
              // For new lines, include all required fields
              targetLine.materialId = Number(line.materialId);
              targetLine.categoryId = Number(line.categoryId);
              targetLine.uomId = Number(line.uomId);
              targetLine.quantity = Number(line.quantitySet);
              targetLine.standardPrice = line.standardPrice ? Number(line.standardPrice) : null;
            }

            boqLinesMap[normalizedBoqLineId].targetLines.push(targetLine);

            // Ensure new BOQ lines have properties from the current line data - ALWAYS set them
            // Check if entry has null id or is a generated ID (both indicate new BOQ line)
            const entryHasNullId =
              boqLinesMap[normalizedBoqLineId].id === null ||
              boqLinesMap[normalizedBoqLineId].id === undefined;
            const needsProperties =
              isNewBoqLine || entryHasNullId || isGeneratedId;

            if (needsProperties) {
              // ALWAYS set all properties from the current line (all lines in same BOQ line have same properties)
              // Force set all properties regardless of whether they exist in line
              if (line.boqLineName) {
                boqLinesMap[normalizedBoqLineId].boqLineName = line.boqLineName;
              }
              if (
                line.siteStructureUnitId !== undefined &&
                line.siteStructureUnitId !== null
              ) {
                boqLinesMap[normalizedBoqLineId].siteStructureUnitId = Number(
                  line.siteStructureUnitId
                );
              }
              if (
                line.siteStructureSubUnitId !== undefined &&
                line.siteStructureSubUnitId !== null
              ) {
                boqLinesMap[normalizedBoqLineId].siteStructureSubUnitId =
                  Number(line.siteStructureSubUnitId);
              }
              if (line.floorNo !== undefined) {
                boqLinesMap[normalizedBoqLineId].floorNo = line.floorNo || null;
              }
              if (line.locationId !== undefined && line.locationId !== null) {
                boqLinesMap[normalizedBoqLineId].locationId = Number(
                  line.locationId
                );
              }
            }
          }
        });

        // Final pass: Ensure all new BOQ lines have required properties
        Object.keys(boqLinesMap).forEach((boqLineIdKey) => {
          const boqLineEntry = boqLinesMap[boqLineIdKey];
          // If it's a new BOQ line (id is null) ensure it has all required properties
          if (
            boqLineEntry &&
            (boqLineEntry.id === null || boqLineEntry.id === undefined)
          ) {
            // Always populate properties for new BOQ lines if they're missing
            if (
              !boqLineEntry.boqLineName ||
              boqLineEntry.siteStructureUnitId === undefined ||
              boqLineEntry.siteStructureSubUnitId === undefined ||
              boqLineEntry.floorNo === undefined ||
              boqLineEntry.locationId === undefined
            ) {
              // Try to find it in current materialData.boqLines first
              let currentBoqLine = (materialData?.boqLines || []).find(
                (bl: any) => {
                  const blId = bl.id?.toString() || bl.key?.toString();
                  const keyStr = boqLineIdKey?.toString();
                  return (
                    blId === keyStr ||
                    bl.key === boqLineIdKey ||
                    bl.id === boqLineIdKey ||
                    bl.key?.toString() === keyStr ||
                    bl.id?.toString() === keyStr
                  );
                }
              );

              // If not found, try to get from any line in currentLines that has this boqLineId
              if (!currentBoqLine) {
                const lineWithBoqLine = currentLines.find((line: any) => {
                  const lineBoqId = line.boqLineId?.toString();
                  const keyStr = boqLineIdKey?.toString();
                  return (
                    lineBoqId === keyStr ||
                    line.boqLineId === boqLineIdKey ||
                    line.boqLineId?.toString() === keyStr
                  );
                });

                if (lineWithBoqLine) {
                  // Create a pseudo-boqLine from the line data
                  currentBoqLine = {
                    boqLineName: lineWithBoqLine.boqLineName,
                    siteStructureUnitId: lineWithBoqLine.siteStructureUnitId,
                    siteStructureSubUnitId:
                      lineWithBoqLine.siteStructureSubUnitId,
                    floorNo: lineWithBoqLine.floorNo,
                    locationId: lineWithBoqLine.locationId,
                  };
                }
              }

              if (currentBoqLine) {
                if (!boqLineEntry.boqLineName) {
                  boqLineEntry.boqLineName =
                    currentBoqLine.boqLineName || "New BOQ Line";
                }
                if (boqLineEntry.siteStructureUnitId === undefined) {
                  boqLineEntry.siteStructureUnitId =
                    currentBoqLine.siteStructureUnitId
                      ? Number(currentBoqLine.siteStructureUnitId)
                      : null;
                }
                if (boqLineEntry.siteStructureSubUnitId === undefined) {
                  boqLineEntry.siteStructureSubUnitId =
                    currentBoqLine.siteStructureSubUnitId
                      ? Number(currentBoqLine.siteStructureSubUnitId)
                      : null;
                }
                if (boqLineEntry.floorNo === undefined) {
                  boqLineEntry.floorNo = currentBoqLine.floorNo || null;
                }
                if (boqLineEntry.locationId === undefined) {
                  boqLineEntry.locationId = currentBoqLine.locationId
                    ? Number(currentBoqLine.locationId)
                    : null;
                }
              }
            }
          }
        });

        // Final aggressive pass: For new BOQ lines, get properties from any line with matching boqLineId
        // Store boqLineId in each entry for easier lookup
        Object.keys(boqLinesMap).forEach((boqLineIdKey) => {
          const boqLineEntry = boqLinesMap[boqLineIdKey];
          // Store the boqLineId for later reference
          boqLineEntry._boqLineIdKey = boqLineIdKey;

          // If it's a new BOQ line and missing ANY required property
          if (
            boqLineEntry &&
            (boqLineEntry.id === null || boqLineEntry.id === undefined)
          ) {
            // FIRST: Try to find in materialData.boqLines (most reliable source)
            let sourceBoqLine = (materialData?.boqLines || []).find(
              (bl: any) => {
                const blId = bl.id?.toString() || bl.key?.toString();
                const keyStr = boqLineIdKey?.toString();
                return (
                  blId === keyStr ||
                  bl.key === boqLineIdKey ||
                  bl.id === boqLineIdKey ||
                  bl.id?.toString() === keyStr ||
                  bl.key?.toString() === keyStr
                );
              }
            );

            // If not found, try matching by boqLineName
            if (!sourceBoqLine && boqLineEntry.boqLineName) {
              const matchingByName = (materialData?.boqLines || []).filter(
                (bl: any) => bl.boqLineName === boqLineEntry.boqLineName
              );
              if (matchingByName.length === 1) {
                sourceBoqLine = matchingByName[0];
              }
            }

            // FALLBACK: Try to find a line with this boqLineId in currentLines
            if (!sourceBoqLine) {
              sourceBoqLine = currentLines.find((line: any) => {
                const lineBoqId = line.boqLineId?.toString();
                const keyStr = boqLineIdKey?.toString();
                return (
                  lineBoqId === keyStr ||
                  line.boqLineId === boqLineIdKey ||
                  line.boqLineId?.toString() === keyStr
                );
              });
            }

            if (sourceBoqLine) {
              // ALWAYS override with values from source (even if null) - but prefer non-null values
              boqLineEntry.boqLineName =
                sourceBoqLine.boqLineName || boqLineEntry.boqLineName || null;

              // Only override if source has a non-null value, otherwise keep existing if it exists
              if (
                sourceBoqLine.siteStructureUnitId !== undefined &&
                sourceBoqLine.siteStructureUnitId !== null
              ) {
                boqLineEntry.siteStructureUnitId = Number(
                  sourceBoqLine.siteStructureUnitId
                );
              } else if (boqLineEntry.siteStructureUnitId === undefined) {
                boqLineEntry.siteStructureUnitId = null;
              }

              if (
                sourceBoqLine.siteStructureSubUnitId !== undefined &&
                sourceBoqLine.siteStructureSubUnitId !== null
              ) {
                boqLineEntry.siteStructureSubUnitId = Number(
                  sourceBoqLine.siteStructureSubUnitId
                );
              } else if (boqLineEntry.siteStructureSubUnitId === undefined) {
                boqLineEntry.siteStructureSubUnitId = null;
              }

              if (
                sourceBoqLine.floorNo !== undefined &&
                sourceBoqLine.floorNo !== null
              ) {
                boqLineEntry.floorNo = sourceBoqLine.floorNo;
              } else if (boqLineEntry.floorNo === undefined) {
                boqLineEntry.floorNo = null;
              }

              if (
                sourceBoqLine.locationId !== undefined &&
                sourceBoqLine.locationId !== null
              ) {
                boqLineEntry.locationId = Number(sourceBoqLine.locationId);
              } else if (boqLineEntry.locationId === undefined) {
                boqLineEntry.locationId = null;
              }
            }
          }
        });

        // Convert map to array and clean up - remove empty targetLines arrays if no BOQ line properties
        const lines = Object.entries(boqLinesMap)
          .map(([boqLineIdKey, boqLine]: [string, any]) => {
            // Remove the temporary _boqLineIdKey property before sending
            const cleanedBoqLine = { ...boqLine };
            delete cleanedBoqLine._boqLineIdKey;

            // For new BOQ lines (id is null), ensure all required properties exist
            if (
              cleanedBoqLine &&
              (cleanedBoqLine.id === null || cleanedBoqLine.id === undefined)
            ) {
              // First, try to get properties from materialData.boqLines (most reliable)
              const boqLineFromData = (materialData?.boqLines || []).find(
                (bl: any) => {
                  const blId = bl.id?.toString() || bl.key?.toString();
                  const keyStr = boqLineIdKey?.toString();
                  return (
                    blId === keyStr ||
                    bl.key === boqLineIdKey ||
                    bl.id === boqLineIdKey ||
                    bl.id?.toString() === keyStr
                  );
                }
              );

              if (boqLineFromData) {
                // Force set all properties from BOQ line data
                cleanedBoqLine.boqLineName =
                  boqLineFromData.boqLineName || null;
                cleanedBoqLine.contractorId =
                  boqLineFromData.contractorId !== undefined &&
                  boqLineFromData.contractorId !== null
                    ? Number(boqLineFromData.contractorId)
                    : null;
                cleanedBoqLine.siteStructureUnitId =
                  boqLineFromData.siteStructureUnitId !== undefined &&
                  boqLineFromData.siteStructureUnitId !== null
                    ? Number(boqLineFromData.siteStructureUnitId)
                    : null;
                cleanedBoqLine.siteStructureSubUnitId =
                  boqLineFromData.siteStructureSubUnitId !== undefined &&
                  boqLineFromData.siteStructureSubUnitId !== null
                    ? Number(boqLineFromData.siteStructureSubUnitId)
                    : null;
                cleanedBoqLine.floorNo = boqLineFromData.floorNo || null;
                cleanedBoqLine.locationId =
                  boqLineFromData.locationId !== undefined &&
                  boqLineFromData.locationId !== null
                    ? Number(boqLineFromData.locationId)
                    : null;
              } else {
                // Fallback: Get properties from currentLines using the boqLineIdKey
                const anyLine = currentLines.find((line: any) => {
                  const lineBoqId = line.boqLineId?.toString();
                  const keyStr = boqLineIdKey?.toString();
                  return (
                    lineBoqId === keyStr ||
                    line.boqLineId === boqLineIdKey ||
                    line.boqLineId?.toString() === keyStr
                  );
                });

                if (anyLine) {
                  // Force set all properties from line data - always override
                  cleanedBoqLine.boqLineName = anyLine.boqLineName || null;
                  cleanedBoqLine.contractorId =
                    anyLine.contractorId !== undefined &&
                    anyLine.contractorId !== null
                      ? Number(anyLine.contractorId)
                      : null;
                  cleanedBoqLine.siteStructureUnitId =
                    anyLine.siteStructureUnitId !== undefined &&
                    anyLine.siteStructureUnitId !== null
                      ? Number(anyLine.siteStructureUnitId)
                      : null;
                  cleanedBoqLine.siteStructureSubUnitId =
                    anyLine.siteStructureSubUnitId !== undefined &&
                    anyLine.siteStructureSubUnitId !== null
                      ? Number(anyLine.siteStructureSubUnitId)
                      : null;
                  cleanedBoqLine.floorNo = anyLine.floorNo || null;
                  cleanedBoqLine.locationId =
                    anyLine.locationId !== undefined &&
                    anyLine.locationId !== null
                      ? Number(anyLine.locationId)
                      : null;
                } else {
                }
              }

              // Don't set null values - only keep properties that have actual values
              // Properties will be set from source data above, we just need to ensure they exist
              // We'll remove null/undefined values at the end before returning

              // Remove id: null for new BOQ lines (as per expected payload format)
              if (
                cleanedBoqLine.id === null ||
                cleanedBoqLine.id === undefined
              ) {
                delete cleanedBoqLine.id;
              }

              // Remove id: null from targetLines for new materials
              if (
                cleanedBoqLine.targetLines &&
                Array.isArray(cleanedBoqLine.targetLines)
              ) {
                cleanedBoqLine.targetLines = cleanedBoqLine.targetLines.map(
                  (tl: any) => {
                    if (tl.id === null || tl.id === undefined) {
                      const { id, ...rest } = tl;
                      return rest;
                    }
                    return tl;
                  }
                );
              }
            }

            // Remove all null and undefined properties from cleanedBoqLine FIRST
            // This ensures we only send fields that have actual values
            Object.keys(cleanedBoqLine).forEach((key) => {
              if (
                cleanedBoqLine[key] === null ||
                cleanedBoqLine[key] === undefined
              ) {
                delete cleanedBoqLine[key];
              }
            });

            // Also clean targetLines - remove null/undefined from each target line
            if (
              cleanedBoqLine.targetLines &&
              Array.isArray(cleanedBoqLine.targetLines)
            ) {
              cleanedBoqLine.targetLines = cleanedBoqLine.targetLines
                .map((tl: any) => {
                  const cleanedTargetLine: any = {};
                  Object.keys(tl).forEach((key) => {
                    if (tl[key] !== null && tl[key] !== undefined) {
                      cleanedTargetLine[key] = tl[key];
                    }
                  });
                  return cleanedTargetLine;
                })
                .filter((tl: any) => Object.keys(tl).length > 0); // Remove empty target lines
            }

            // IMPORTANT: If targetLines has items, ALWAYS include the line (even if site hierarchy properties are null)
            // Only exclude if there are NO targetLines AND no other properties
            if (
              cleanedBoqLine.targetLines &&
              cleanedBoqLine.targetLines.length > 0
            ) {
              // Has targetLines - always include, even if site hierarchy properties are null
            } else if (
              !cleanedBoqLine.targetLines ||
              cleanedBoqLine.targetLines.length === 0
            ) {
              // No targetLines - check if there are other properties
              const hasProperties = Object.keys(cleanedBoqLine).some(
                (key) =>
                  key !== "id" &&
                  key !== "targetLines" &&
                  cleanedBoqLine[key] !== undefined &&
                  cleanedBoqLine[key] !== null
              );
              if (!hasProperties) {
                return null;
              }
              // If no targetLines but has properties, remove empty targetLines array
              delete cleanedBoqLine.targetLines;
            }

            return cleanedBoqLine;
          })
          .filter((line: any) => line !== null);

        // Always include lines if there are any changes detected
        if (
          lines.length > 0 ||
          targetLinesToDelete.length > 0 ||
          boqLinesToDelete.length > 0
        ) {
          if (lines.length > 0) {
            payload.lines = lines;
          }
          if (targetLinesToDelete.length > 0) {
            payload.targetLinesToDelete = targetLinesToDelete;
          }
          if (boqLinesToDelete.length > 0) {
            payload.boqLinesToDelete = boqLinesToDelete;
          }
        }
      }

      // Check if there are any changes at all
      if (Object.keys(payload).length === 0) {
        Swal.fire("Info", "No changes detected.", "info");
        setDisableSubmit(false);
        return;
      }

      // Always send targetId as query parameter
      const res = await boqApis.newVersionboq(
        payload,
        materialData?.header?.targetId
      );
      const { status, message }: any = res;
      if (status) {
        await fetchBoqDetails();
        Swal.fire("Updated!", message, "success");
        setDisableSubmit(false);
        // Don't redirect - stay on the same page
        // navigate("/consumption-target-list");
      } else {
        Swal.fire("Error!", message, "error");
        setDisableSubmit(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Head title="BOQ - Details" />

      {/* Modal to Update General Information */}
      <Modal
        isOpen={ConsumptionTarget_GeneralDetailsEdit}
        toggle={() => setConsumptionTarget_GeneralDetailsEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setConsumptionTarget_GeneralDetailsEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <ModalBody>
          <>
            <h5 className="title">Update General Information</h5>
            <div style={{ marginTop: "15px" }}></div>

            <FormProvider {...methods}>
              <form
                className="content claerfix"
                onSubmit={handleSubmit((data) => {
                  setMaterialData((pre: any) => {
                    // Convert notifyUsers back to boqUsers format for view display
                    const updatedBoqUsers = data?.notifyUsers
                      ? (Array.isArray(data.notifyUsers)
                          ? data.notifyUsers
                          : [data.notifyUsers]
                        ).map((id: any) => {
                          const user = usersOptions.find((u) => u.value === id?.toString());
                          return { userId: Number(id), userName: user?.label || id };
                        })
                      : pre.header?.boqUsers || [];

                    const newheader = {
                      ...pre.header,
                      ...data,
                      boqUsers: updatedBoqUsers,
                      siteName: sitesOptions.find(
                        (item) =>
                          item.value == (data?.siteId || pre.header?.siteId)
                      )?.label,
                    };

                    const updatedMaterialData = {
                      ...pre,
                      header: newheader,
                    };
                    return updatedMaterialData;
                  });

                  setConsumptionTarget_GeneralDetailsEdit(false);
                  setAddNewRowModel(false);
                  setEditLineRow(null);
                  setShowSubmitBtm(true);
                })}
              >
                <Row className="gy-4">
                  <Col lg="4">
                    <FormInput
                      name="boqTitle"
                      label="BOQ Title"
                      required={true}
                      type="text"
                      disabled={materialData?.header?.isEditable === false}
                      placeholder="Enter BOQ Title"
                      tooltipText="Enter BOQ Title"
                    />
                  </Col>
                  <Col lg="4">
                    <FormInput
                      name="targetNumber"
                      label="BOQ ID"
                      required={true}
                      type="text"
                      disabled={materialData?.header?.isEditable === false}
                      placeholder="Enter BOQ ID"
                      tooltipText="Enter BOQ ID"
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="siteId"
                      label="Site"
                      options={sitesOptions}
                      required={true}
                      disabled
                      placeholder="-Select-"
                      tooltipText="Select the site where the materials will be used."
                    />
                  </Col>
                </Row>
                <Row className="gy-4 mt-1">
                  {(workLevelSetting || materialData?.header?.segmentLevel) && (
                    <Col lg="4">
                      <FormSelect
                        name="workLevelSetting"
                        label="Site Hierarchy"
                        options={[
                          { label: "Tower / Block", value: "TOWER_BLOCK" },
                          { label: "Villa", value: "VILLA" },
                          { label: "Floor", value: "FLOOR" },
                          { label: "Flat", value: "FLAT" },
                        ]}
                        disabled
                        placeholder="-Select-"
                        tooltipText="Site Hierarchy level for this BOQ."
                      />
                    </Col>
                  )}
                  <Col lg="4">
                    <FormSelect
                      name="limitPostTargetConsumption"
                      label="Limit Material Issue"
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      placeholder="-Select-"
                      tooltipText="Material cannot be issued without approvals to site post BOQ Consumption."
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="limitPostTargetOrder"
                      label="Limit PO?"
                      options={[
                        { label: "Yes", value: "Yes" },
                        { label: "No", value: "No" },
                      ]}
                      placeholder="-Select-"
                      tooltipText="Purchase orders cannot be released without approvals post exceeding BOQ purchases."
                    />
                  </Col>
                  <Col lg="4">
                    <FormMultiSelect
                      name="setAlerts"
                      label="Consumption Percentage"
                      options={Array.from({ length: 20 }, (_, i) => {
                        const value = (i + 1) * 5;
                        return {
                          label: value.toString(),
                          value: value.toString(),
                        };
                      })}
                      placeholder="-Select-"
                      tooltipText="Select Limit."
                    />
                  </Col>
                  {Array.isArray(setAlertsWatch) && setAlertsWatch.length > 0 && (
                    <Col lg="4">
                      <FormMultiSelect
                        name="notifyUsers"
                        label="Notify Users"
                        required={true}
                        options={usersOptions}
                        placeholder="Select Users to Notify"
                      />
                    </Col>
                  )}
                </Row>

                <Row className="mt-4">
                  <Col lg="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          className="btn btn-primary btn-md"
                          type="submit"
                          color="primary"
                        >
                          Save
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setConsumptionTarget_GeneralDetailsEdit(false);
                            reset();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </form>
            </FormProvider>
          </>
        </ModalBody>
      </Modal>
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {/* <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
                }`}
            >
              <BOQAside updateSm={setSm} sm={sm} />
            </div> */}
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span>
                          Target Id -{" "}
                          {materialData?.header?.boqTitle
                            ? materialData?.header?.boqTitle
                            : materialData?.header?.targetNumber}{" "}
                          {"|"} {materialData?.header?.status}{" "}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    <div className="d-flex">
                      {showSubmitBtm && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            <li className="pt-0 pb-0">
                              {disableSubmit ? (
                                <Button color="primary" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  type="button"
                                  disabled={!canSaveChanges}
                                  onClick={() => {
                                    if (!canSaveChanges) {
                                      Swal.fire({
                                        icon: "warning",
                                        title: "Cannot Save",
                                        text: "Please add at least one material to all BOQ lines before saving.",
                                      });
                                      return;
                                    }
                                    setDisableSubmit(true);
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to submit the changes?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, submit it!",
                                      cancelButtonText: "No, cancel",
                                    }).then(async (result) => {
                                      if (result.isConfirmed) {
                                        await SubmitChanges();
                                      } else {
                                        setDisableSubmit(false);
                                      }
                                    });
                                  }}
                                >
                                  Save Changes
                                </Button>
                              )}
                            </li>
                            <li className="pt-0 pb-0">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to revert the changes?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, revert it!",
                                    cancelButtonText: "No, cancel",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      fetchBoqDetails();
                                      Swal.fire(
                                        "Reverted!",
                                        "Your changes have been reverted.",
                                        "success"
                                      );
                                    } else {
                                      setDisableSubmit(false);
                                    }
                                  });
                                }}
                                type="button"
                                className="btn-dim btn btn-secondary"
                              >
                                Revert Changes
                              </Button>
                            </li>
                          </ul>
                        </div>
                      )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate(-1);
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>
                      )}
                    </div>
                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${
                          sm ? "active" : ""
                        }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>

                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel header="General Information" key="1">
                      {status !== "IN_PROGRESS" && status !== "REJECTED" && (
                        <span
                          className="cursor-pointer position-absolute"
                          style={{
                            right: 40,
                            top: 75,
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setValue(
                              "boqTitle",
                              materialData?.header?.boqTitle
                            );
                            setValue(
                              "targetNumber",
                              materialData?.header?.targetNumber
                            );
                            setValue(
                              "siteId",
                              materialData?.header?.siteId?.toString()
                            );
                            setValue(
                              "limitPostTargetConsumption",
                              materialData?.header
                                ?.limitPostTargetConsumption === 1 ||
                                materialData?.header
                                  ?.limitPostTargetConsumption === "Yes"
                                ? "Yes"
                                : "No"
                            );
                            setValue(
                              "limitPostTargetOrder",
                              materialData?.header?.limitPostTargetOrder ===
                                1 ||
                                materialData?.header?.limitPostTargetOrder ===
                                  "Yes"
                                ? "Yes"
                                : "No"
                            );
                            setValue(
                              "setAlerts",
                              materialData?.header.setAlerts
                            );
                            setValue(
                              "notifyUsers",
                              materialData?.header.boqUsers
                                ? materialData.header.boqUsers.map(
                                    (u: any) => u.userId?.toString()
                                  )
                                : []
                            );
                            if (workLevelSetting) {
                              setValue("workLevelSetting", workLevelSetting);
                            }
                            setConsumptionTarget_GeneralDetailsEdit(true);
                          }}
                        >
                          <Icon name="edit" />
                        </span>
                      )}
                      <Col className="justify-start w-100 flex-wrap mt-1">
                        <div className="w-30 border-end">
                          <div className="data-col align-center pt-1">
                            <div className="data-label w-45">BOQ Title</div>
                            <div className="data-value w-55">
                              {materialData?.header?.boqTitle || "N/A"}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1">
                            <div className="data-label w-45">Site</div>
                            <div className="data-value w-55">
                              {
                                sitesOptions.find(
                                  (item) =>
                                    item.value == materialData?.header?.siteId
                                )?.label
                              }
                            </div>
                          </div>
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-45">
                              {" "}
                              Limit Material Issue{" "}
                            </div>
                            <div className="data-value w-55 ">
                              {materialData?.header
                                ?.limitPostTargetConsumption === 1 ||
                              materialData?.header
                                ?.limitPostTargetConsumption === "Yes"
                                ? "Yes"
                                : "No"}
                            </div>
                          </div>
                        </div>
                        <div className="w-30 border-end paddingLeft10  ">
                          <div className="data-col align-center pt-1">
                            <div className="data-label w-45">BOQ ID</div>
                            <div className="data-value w-55">
                              {materialData?.header?.targetNumber}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-45"> Limit PO? </div>
                            <div className="data-value w-55 ">
                              {materialData?.header?.limitPostTargetOrder === 1
                                ? "Yes"
                                : "No"}
                            </div>
                          </div>
                        </div>
                        <div className="w-30 paddingLeft10">
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-40">
                              Site Hierarchy
                            </div>
                            <div className="data-value w-55 ">
                              {(() => {
                                const level =
                                  workLevelSetting ||
                                  materialData?.header?.segmentLevel;
                                if (
                                  level === "TOWER_BLOCK" ||
                                  level === "Tower"
                                )
                                  return "Tower / Block";
                                if (level === "VILLA" || level === "Villa")
                                  return "Villa";
                                if (level === "FLOOR" || level === "Floor")
                                  return "Floor";
                                if (level === "FLAT" || level === "Flat")
                                  return "Flat";
                                return level || "Site";
                              })()}
                            </div>
                          </div>
                          <div className="data-col align-center pt-1 ">
                            <div className="data-label w-40">
                              {" "}
                              Consumption Percentage
                            </div>
                            <div className="data-value w-55 ">
                              {materialData?.header?.setAlerts &&
                              Array.isArray(materialData?.header?.setAlerts) &&
                              materialData?.header?.setAlerts.length > 0
                                ? materialData?.header?.setAlerts.join(", ")
                                : "N/A"}
                            </div>
                          </div>
                          {materialData?.header?.setAlerts &&
                            Array.isArray(materialData?.header?.setAlerts) &&
                            materialData?.header?.setAlerts.length > 0 && (
                              <div className="data-col align-center pt-1 ">
                                <div className="data-label w-40">
                                  Notify Users
                                </div>
                                <div className="data-value w-55 ">
                                  {materialData?.header?.boqUsers &&
                                  Array.isArray(
                                    materialData?.header?.boqUsers
                                  ) &&
                                  materialData?.header?.boqUsers.length > 0
                                    ? materialData?.header?.boqUsers
                                        .map((boqUser: any) => {
                                          if (boqUser.userName) return boqUser.userName;
                                          const user = usersOptions.find((u) => u.value === boqUser.userId?.toString());
                                          return user?.label || boqUser.userId;
                                        })
                                        .join(", ")
                                    : "N/A"}
                                </div>
                              </div>
                            )}
                        </div>
                      </Col>
                    </Panel>
                    <Panel header="Material Information" key="2">
                      <div className="table-responsive poTable">
                        <div style={{ margin: "auto", marginBottom: 20 }}>
                          <Table
                            className="customTable"
                            columns={boqLineColumns}
                            dataSource={boqLinesData.map(
                              (boqLine: any, index: number) => ({
                                ...boqLine,
                                key:
                                  boqLine?.id?.toString() || `boqLine-${index}`,
                                index,
                              })
                            )}
                            scroll={{ x: 1000 }}
                            expandable={{
                              expandedRowRender: (record: any) => {
                                const materials = record.materials || [];
                                return (
                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <p
                                        style={{
                                          margin: 0,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Materials
                                      </p>
                                    </div>
                                    {materials.length === 0 ? (
                                      <div
                                        style={{
                                          padding: "10px",
                                          textAlign: "center",
                                          color: "#999",
                                        }}
                                      >
                                        <p>
                                          No materials added to this BOQ Line.
                                        </p>
                                      </div>
                                    ) : (
                                      <div className="mt-3">
                                        <Table
                                          className="customTable"
                                          columns={materialColumns}
                                          dataSource={materials.map(
                                            (material: any, index: number) => ({
                                              ...material,
                                              key: material?.id || index,
                                            })
                                          )}
                                          scroll={{ x: 800 }}
                                          bordered
                                          size="small"
                                          pagination={false}
                                        />
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        marginTop: 10,
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                      }}
                                    >
                                      {status !== "IN_PROGRESS" &&
                                        status !== "REJECTED" && (
                                          <span
                                            onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              setSelectedBoqLineForMaterial(
                                                record
                                              );
                                              setEditLineRow(null);
                                              setAddNewRowModel(true);
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: 14,
                                              color: "#2263b3",
                                            }}
                                          >
                                            <Icon name="plus-round"></Icon>{" "}
                                            &nbsp; Add Material
                                          </span>
                                        )}
                                    </div>
                                  </div>
                                );
                              },
                              expandedRowKeys,
                              onExpand: (expanded: boolean, record: any) => {
                                if (expanded) {
                                  setExpandedRowKeys((prevKeys) => [
                                    ...prevKeys,
                                    record.key,
                                  ]);
                                } else {
                                  setExpandedRowKeys((prevKeys) =>
                                    prevKeys.filter((key) => key !== record.key)
                                  );
                                }
                              },
                              rowExpandable: (record: any) => true,
                            }}
                            bordered
                            size="small"
                            pagination={false}
                            locale={{
                              emptyText: (
                                <span
                                  style={{
                                    height: "300px",
                                    color: "#333",
                                    fontSize: "16px",
                                  }}
                                >
                                  Please click on "Add New Item" to add
                                  materials.
                                </span>
                              ),
                            }}
                          />
                        </div>
                        {/* Add BOQ Line Button - below table like creation */}
                        {/* Hide button only if site hierarchy is NOT selected AND one BOQ line exists */}
                        {!(
                          status !== "IN_PROGRESS" &&
                          status !== "REJECTED" &&
                          !workLevelSetting &&
                          boqLinesData.length > 0
                        ) && (
                          <div
                            style={{
                              marginTop: 10,
                              display: "flex",
                              gap: "15px",
                              alignItems: "center",
                            }}
                          >
                            {status !== "IN_PROGRESS" &&
                              status !== "REJECTED" && (
                                <span
                                  onClick={() => {
                                    if (canAddBOQLine) {
                                      setEditBoqLineRow(null);
                                      setAddBoqLineModal(true);
                                    }
                                  }}
                                  style={{
                                    cursor: canAddBOQLine
                                      ? "pointer"
                                      : "not-allowed",
                                    fontSize: 14,
                                    color: canAddBOQLine ? "#2263b3" : "#999",
                                    opacity: canAddBOQLine ? 1 : 0.6,
                                  }}
                                >
                                  <Icon name="plus-round"></Icon> &nbsp; Add BOQ
                                  Line
                                </span>
                              )}
                          </div>
                        )}
                      </div>
                    </Panel>
                  </AntCollapse>
                  <Block>
                    {addBoqLineModal && (
                      <AddBOQLineModal
                        isOpen={addBoqLineModal}
                        onClose={() => {
                          setAddBoqLineModal(false);
                          setEditBoqLineRow(null);
                        }}
                        workLevelSetting={workLevelSetting || null}
                        siteId={
                          materialData?.header?.siteId?.toString() || null
                        }
                        editData={editBoqLineRow}
                        existingBoqLines={boqLinesData}
                        onSubmit={(boqLineData: any) => {
                          const existingLines = boqLinesData || [];
                          const isEdit = !!editBoqLineRow;

                          // Check duplicate BOQ Line Name
                          const duplicateName = existingLines.some(
                            (line: any) => {
                              if (isEdit && (line.id === editBoqLineRow?.id || line.key === editBoqLineRow?.key)) return false;
                              return line.boqLineName?.trim()?.toLowerCase() === boqLineData.boqLineName?.trim()?.toLowerCase();
                            }
                          );
                          if (duplicateName) {
                            Swal.fire({ icon: "error", title: "Duplicate BOQ Line Name", text: "A BOQ line with the same name already exists. Please use a different name." });
                            return;
                          }

                          // Check duplicate hierarchy combination
                          const wls = workLevelSetting;
                          let isDuplicate = false;
                          let errorMessage = "";
                          if (wls === "TOWER_BLOCK" || wls === "VILLA") {
                            if (boqLineData.siteStructureUnitId) {
                              isDuplicate = existingLines.some((line: any) => {
                                if (isEdit && (line.id === editBoqLineRow?.id || line.key === editBoqLineRow?.key)) return false;
                                return line.siteStructureUnitId?.toString() === boqLineData.siteStructureUnitId?.toString();
                              });
                              if (isDuplicate) errorMessage = "Each tower/villa can have only one BOQ line. Please select a different tower/villa.";
                            }
                          } else if (wls === "FLOOR") {
                            if (boqLineData.siteStructureUnitId && boqLineData.floorNo) {
                              isDuplicate = existingLines.some((line: any) => {
                                if (isEdit && (line.id === editBoqLineRow?.id || line.key === editBoqLineRow?.key)) return false;
                                return line.siteStructureUnitId?.toString() === boqLineData.siteStructureUnitId?.toString() && line.floorNo?.toString() === boqLineData.floorNo?.toString();
                              });
                              if (isDuplicate) errorMessage = "Each floor (Tower/Block + Floor) can have only one BOQ line.";
                            }
                          } else if (wls === "FLAT") {
                            if (boqLineData.siteStructureUnitId && boqLineData.floorNo && boqLineData.siteStructureSubUnitId) {
                              isDuplicate = existingLines.some((line: any) => {
                                if (isEdit && (line.id === editBoqLineRow?.id || line.key === editBoqLineRow?.key)) return false;
                                return line.siteStructureUnitId?.toString() === boqLineData.siteStructureUnitId?.toString() && line.floorNo?.toString() === boqLineData.floorNo?.toString() && line.siteStructureSubUnitId?.toString() === boqLineData.siteStructureSubUnitId?.toString();
                              });
                              if (isDuplicate) errorMessage = "Each flat (Tower/Block + Floor + Flat) can have only one BOQ line.";
                            }
                          }
                          if (isDuplicate) {
                            Swal.fire({ icon: "error", title: "Duplicate BOQ Line", text: errorMessage });
                            return;
                          }

                          const newBoqLineId =
                            editBoqLineRow?.id ||
                            `boqLine-${Date.now()}-${Math.random()}`;

                          // Lookup names from options arrays
                          const towerName = boqLineData.siteStructureUnitId
                            ? towerOptions.find(
                                (item) =>
                                  item.value ===
                                    boqLineData.siteStructureUnitId?.toString() ||
                                  Number(item.value) ===
                                    Number(boqLineData.siteStructureUnitId)
                              )?.label
                            : null;
                          const flatName = boqLineData.siteStructureSubUnitId
                            ? flatOptions.find(
                                (item) =>
                                  item.value ===
                                    boqLineData.siteStructureSubUnitId?.toString() ||
                                  Number(item.value) ===
                                    Number(boqLineData.siteStructureSubUnitId)
                              )?.label ||
                              editBoqLineRow?.siteStructureSubUnitName
                            : null;
                          const locationName = boqLineData.locationId
                            ? locationOptions.find(
                                (item) =>
                                  item.value ===
                                    boqLineData.locationId?.toString() ||
                                  Number(item.value) ===
                                    Number(boqLineData.locationId)
                              )?.label
                            : null;

                          const contractorName = boqLineData.contractorName ||
                            (boqLineData.contractorId
                            ? contractorOptions.find(
                                (item) =>
                                  item.value === boqLineData.contractorId?.toString()
                              )?.label
                            : null);

                          const newBoqLine = {
                            id: editBoqLineRow?.id || newBoqLineId,
                            key: editBoqLineRow?.key || newBoqLineId,
                            boqLineName: boqLineData.boqLineName,
                            contractorId: boqLineData.contractorId,
                            contractorName:
                              contractorName ||
                              editBoqLineRow?.contractorName ||
                              null,
                            siteStructureUnitId:
                              boqLineData.siteStructureUnitId,
                            siteStructureUnitName:
                              towerName ||
                              editBoqLineRow?.siteStructureUnitName ||
                              null,
                            siteStructureSubUnitId:
                              boqLineData.siteStructureSubUnitId,
                            siteStructureSubUnitName:
                              flatName ||
                              editBoqLineRow?.siteStructureSubUnitName ||
                              null,
                            floorNo: boqLineData.floorNo,
                            locationId: boqLineData.locationId,
                            locationName:
                              locationName ||
                              editBoqLineRow?.locationName ||
                              null,
                            materials: editBoqLineRow?.materials || [],
                            targetLines: editBoqLineRow?.targetLines || [],
                            isEditable: true,
                          };

                          if (editBoqLineRow) {
                            // Update existing BOQ line
                            setMaterialData((prev: any) => {
                              const updatedBoqLines = (prev.boqLines || []).map(
                                (bl: any) => {
                                  if (
                                    bl.id === editBoqLineRow.id ||
                                    bl.key === editBoqLineRow.key
                                  ) {
                                    return {
                                      ...bl,
                                      ...newBoqLine,
                                      // Ensure names are included
                                      contractorName:
                                        contractorName || bl.contractorName,
                                      siteStructureUnitName:
                                        towerName || bl.siteStructureUnitName,
                                      siteStructureSubUnitName:
                                        flatName || bl.siteStructureSubUnitName,
                                      locationName:
                                        locationName || bl.locationName,
                                    };
                                  }
                                  return bl;
                                }
                              );
                              // Update lines with new BOQ line data
                              const updatedLines = (prev.lines || []).map(
                                (line: any) => {
                                  const lineBoqLineId =
                                    line.boqLineId?.toString();
                                  const recordId =
                                    editBoqLineRow.id?.toString() ||
                                    editBoqLineRow.key?.toString();
                                  if (lineBoqLineId === recordId) {
                                    return {
                                      ...line,
                                      boqLineName: newBoqLine.boqLineName,
                                      siteStructureUnitId:
                                        newBoqLine.siteStructureUnitId,
                                      siteStructureSubUnitId:
                                        newBoqLine.siteStructureSubUnitId,
                                      floorNo: newBoqLine.floorNo,
                                      locationId: newBoqLine.locationId,
                                    };
                                  }
                                  return line;
                                }
                              );
                              return {
                                ...prev,
                                boqLines: updatedBoqLines,
                                lines: updatedLines,
                              };
                            });
                          } else {
                            // Add new BOQ line
                            setMaterialData((prev: any) => {
                              return {
                                ...prev,
                                boqLines: [
                                  ...(prev.boqLines || []),
                                  newBoqLine,
                                ],
                              };
                            });
                            // Auto-expand the newly added BOQ line
                            const newBoqLineKey =
                              newBoqLine.id || newBoqLine.key;
                            setExpandedRowKeys((prevKeys) => [
                              ...prevKeys,
                              newBoqLineKey.toString(),
                            ]);
                          }
                          setShowSubmitBtm(true);
                          setAddBoqLineModal(false);
                          setEditBoqLineRow(null);
                        }}
                      />
                    )}
                    {addNewRowModel && (
                      <BoqMaterialModal
                        modal={addNewRowModel}
                        closeModal={() => {
                          setAddNewRowModel(false);
                          setEditLineRow(null);
                          setSelectedBoqLineForMaterial(null);
                        }}
                        materialCategoryOptions={materialCategoryOptions}
                        status={materialData?.header?.status}
                        formData={{
                          action: editLineRow == null ? "add" : "edit",
                          index: editLineRow?.id,
                          item: editLineRow,
                        }}
                        append={(data: any) => {
                          let newLineItems = materialData?.lines || [];

                          // Check for duplicates in the same BOQ line
                          const boqLineId =
                            selectedBoqLineForMaterial?.id ||
                            selectedBoqLineForMaterial?.key;

                          // Check in flat lines array
                          const duplicateInLines = newLineItems.find(
                            (item: any) =>
                              item.materialId == data.materialId &&
                              (item.boqLineId?.toString() ===
                                boqLineId?.toString() ||
                                (!item.boqLineId && !boqLineId))
                          );

                          // Also check in boqLine's targetLines/materials
                          const currentBoqLine = (materialData?.boqLines || []).find(
                            (bl: any) =>
                              bl.id?.toString() === boqLineId?.toString() ||
                              bl.key === boqLineId
                          );
                          const duplicateInBoqLine = (
                            currentBoqLine?.targetLines ||
                            currentBoqLine?.materials ||
                            []
                          ).find(
                            (item: any) => item.materialId == data.materialId
                          );

                          if (duplicateInLines || duplicateInBoqLine) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: "Material Already Added",
                            });
                            return;
                          }

                          // Add boqLineId to the material data
                          const materialWithBoqLine = {
                            ...data,
                            boqLineId: boqLineId || `boqLine-${Date.now()}`,
                            boqLineName:
                              selectedBoqLineForMaterial?.boqLineName ||
                              "BOQ Line 1",
                            siteStructureUnitId:
                              selectedBoqLineForMaterial?.siteStructureUnitId,
                            siteStructureSubUnitId:
                              selectedBoqLineForMaterial?.siteStructureSubUnitId,
                            floorNo: selectedBoqLineForMaterial?.floorNo,
                            locationId: selectedBoqLineForMaterial?.locationId,
                          };

                          setMaterialData((prev: any) => {
                            const updatedLines = [
                              ...prev.lines,
                              materialWithBoqLine,
                            ];
                            // Update boqLines to include the new material
                            const updatedBoqLines = (prev.boqLines || []).map(
                              (bl: any) => {
                                if (
                                  bl.id?.toString() === boqLineId?.toString() ||
                                  bl.key === boqLineId
                                ) {
                                  return {
                                    ...bl,
                                    materials: [
                                      ...(bl.materials || []),
                                      materialWithBoqLine,
                                    ],
                                    targetLines: [
                                      ...(bl.targetLines || []),
                                      materialWithBoqLine,
                                    ],
                                  };
                                }
                                return bl;
                              }
                            );

                            return {
                              ...prev,
                              lines: updatedLines,
                              boqLines: updatedBoqLines,
                            };
                          });

                          setShowSubmitBtm(true);
                          setSelectedBoqLineForMaterial(null);
                        }}
                        update={(id: any, data: any) => {
                          let newLineItems = materialData?.lines || [];

                          // Find the original item being edited
                          const originalItem = newLineItems.find(
                            (item: any) => {
                              if (
                                id != null &&
                                id !== undefined &&
                                item.id != null &&
                                item.id !== undefined
                              ) {
                                return Number(item.id) === Number(id);
                              }
                              // Fallback: if no id, try to match by materialId (for new items)
                              return (
                                item.materialId == data.materialId &&
                                item.id == id
                              );
                            }
                          );

                          // Get the boqLineId from the original item
                          const boqLineId =
                            originalItem?.boqLineId ||
                            data?.boqLineId ||
                            selectedBoqLineForMaterial?.id ||
                            selectedBoqLineForMaterial?.key;

                          // Only check for duplicates if materialId is being changed to a different material
                          if (
                            originalItem &&
                            Number(originalItem.materialId) !==
                              Number(data.materialId)
                          ) {
                            const _data = newLineItems
                              .filter((item: any) => {
                                // Exclude the current item being edited
                                if (
                                  id != null &&
                                  id !== undefined &&
                                  item.id != null &&
                                  item.id !== undefined
                                ) {
                                  return Number(item.id) !== Number(id);
                                }
                                return item !== originalItem;
                              })
                              .find(
                                (item: any) =>
                                  Number(item.materialId) ===
                                    Number(data.materialId) &&
                                  (item.boqLineId?.toString() ===
                                    boqLineId?.toString() ||
                                    (!item.boqLineId && !boqLineId))
                              );

                            if (_data) {
                              Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: "Material Already Added",
                              });
                              return;
                            }
                          }

                          // Preserve boqLineId and other BOQ line properties from original item
                          const updatedData = {
                            ...data,
                            boqLineId: boqLineId || originalItem?.boqLineId,
                            boqLineName:
                              originalItem?.boqLineName ||
                              selectedBoqLineForMaterial?.boqLineName,
                            siteStructureUnitId:
                              originalItem?.siteStructureUnitId ||
                              selectedBoqLineForMaterial?.siteStructureUnitId,
                            siteStructureSubUnitId:
                              originalItem?.siteStructureSubUnitId ||
                              selectedBoqLineForMaterial?.siteStructureSubUnitId,
                            floorNo:
                              originalItem?.floorNo ||
                              selectedBoqLineForMaterial?.floorNo,
                            locationId:
                              originalItem?.locationId ||
                              selectedBoqLineForMaterial?.locationId,
                          };

                          const updatedLines = newLineItems.map((item: any) => {
                            if (
                              id != null &&
                              id !== undefined &&
                              item.id != null &&
                              item.id !== undefined
                            ) {
                              if (Number(item.id) === Number(id)) {
                                return updatedData;
                              }
                            } else if (
                              id == null &&
                              item.id == null &&
                              Number(item.materialId) ===
                                Number(data.materialId)
                            ) {
                              return updatedData;
                            }
                            return item;
                          });

                          setMaterialData((prev: any) => {
                            // Update boqLines to reflect the material update
                            const updatedBoqLines = (prev.boqLines || []).map(
                              (bl: any) => {
                                const blId =
                                  bl.id?.toString() || bl.key?.toString();
                                const lineBoqId = boqLineId?.toString();

                                if (
                                  blId === lineBoqId ||
                                  bl.key === boqLineId ||
                                  bl.id === boqLineId
                                ) {
                                  return {
                                    ...bl,
                                    materials: (bl.materials || []).map(
                                      (m: any) => {
                                        if (
                                          m.id != null &&
                                          id != null &&
                                          m.id !== undefined &&
                                          id !== undefined
                                        ) {
                                          if (Number(m.id) === Number(id)) {
                                            return updatedData;
                                          }
                                        }
                                        return m;
                                      }
                                    ),
                                    targetLines: (bl.targetLines || []).map(
                                      (tl: any) => {
                                        if (
                                          tl.id != null &&
                                          id != null &&
                                          tl.id !== undefined &&
                                          id !== undefined
                                        ) {
                                          if (Number(tl.id) === Number(id)) {
                                            return updatedData;
                                          }
                                        }
                                        return tl;
                                      }
                                    ),
                                  };
                                }
                                return bl;
                              }
                            );

                            return {
                              ...prev,
                              lines: updatedLines,
                              boqLines: updatedBoqLines,
                            };
                          });

                          setData(updatedLines);
                          setShowSubmitBtm(true);
                        }}
                      />
                    )}
                  </Block>
                </div>
              </div>
            )}
          </div>
        </Card>
      </Content>
    </>
  );
};

export default ViewBoqDetails;
